import MarketProfileCharts from "../../pages/dashboard/market_profile";
import LineChart from "../../pages/dashboard/line_chart";
import BarChart from "../../pages/dashboard/bar_chart";
import StockChartHV from "../../pages/dashboard/stock_chart_hv";
import StockChart from "../../pages/dashboard/stock_chart";
import OPTIONS_TABLE from "../../pages/dashboard/options_table";
import {
    ALLOWED_ROLES_ORDERFLOW,
    USER_RESOURCES_LIST,
    USER_ROLE_FIELDS,
} from "./constant";
import {
    ALLOWED_ROLES_ADMIN,
    ALLOWED_ROLES_ALL,
    ALLOWED_ROLES_PREMIUM,
    ALLOWED_ROLES_ELITE,
    ALLOWED_ROLES_PRO2,
    ALLOWED_ROLES_BASIC,
    RESOURCE_LIST,
    RESOURCE_LIST_TBT,
} from "./constant";
// ============================================================
// NEW - Centralized Permission System
// See: src/common/utility/permissionService.js
// ============================================================
import { createPermissionService } from "./permissionService";
import { TIERS } from "./roleConstants";
import GREEKS_TABLE from "../../pages/dashboard/greeks_table";
import INDEX_TABLE from "../../pages/dashboard/index_table";
import Bookmark from "@mui/icons-material/Bookmark";
import OrderflowCharts from "../../pages/dashboard/orderflow";
import LineChartMain from "../../pages/dashboard/LineChartMain";
import CandlestickCharts from "../../pages/dashboard/candlestick_main";
import LineChartMainNew from "../../pages/dashboard/LineChartMainNew";
import LineChartNew from "../../pages/dashboard/line_chart_new";
import GlobalBookmarks from "../../pages/dashboard/global_bookmarks";
import { subscribe } from "firebase/data-connect";
import PAYOFF_CHART from "../../pages/dashboard/payoff_chart";
// import SubscriptionNew from "../../pages/dashboard/subscription_new";

const IV_RANGE_CHART_STATE_TEMPLATE = {
    data: {
        chart_type: "lc",
        type: "SINGLE",
        startDate: "",
        nDays: 1,
        prem: "",
        plot: "spt_ivr",
        fvol: "0",
        doix: "0",
        trp: "0",
        gf: "0",
        gr: "0",
        gm: "0",
    },
};

function createIvRangeChartState(symbol) {
    const prefix =
        symbol === "SENSEX"
            ? "SNX"
            : symbol === "NIFTY"
              ? "NF"
              : symbol === "BANKNIFTY"
                ? "BN"
                : symbol === "FINNIFTY"
                  ? "FN"
                  : symbol === "MIDCPNIFTY"
                    ? "MN"
                    : symbol.slice(0, 2).toUpperCase();
    const key = `${prefix} IV Range Charts`;
    return {
        key,
        name: key,
        title: `${symbol} IV Range`,
        roles: ALLOWED_ROLES_ELITE,
        data: { ...IV_RANGE_CHART_STATE_TEMPLATE.data, symbol },
    };
}

export const NIFTY_IV_RANGE_CHART_DATA = createIvRangeChartState("NIFTY");
export const SENSEX_IV_RANGE_CHART_DATA = createIvRangeChartState("SENSEX");

export const NIFTY_SPOT_OIX_CHART_DATA = {
    key: "NF Options Strike Spectrum Charts",
    name: "NF Options Strike Spectrum Charts",
    title: "NIFTY Options Strike Spectrum Charts",
    data: {
        chart_type: "lc",
        symbol: "NIFTY",
        type: "SINGLE",
        startDate: "",
        nDays: 4,
        prem: "fut",
        plot: "spt",
        fvol: "0",
        doix: "0",
        trp: "0",
        gf: "1",
        gr: "1",
        gm: "1",
    },
};

export const BANKNIFTY_SPOT_OIX_CHART_DATA = {
    key: "BN Options Strike Spectrum Charts",
    name: "BN Options Strike Spectrum Charts",
    title: "BANKNIFTY Options Strike Spectrum Charts",
    data: {
        chart_type: "lc",
        symbol: "BANKNIFTY",
        type: "SINGLE",
        startDate: "",
        nDays: 4,
        prem: "fut",
        plot: "spt",
        fvol: "0",
        doix: "0",
        trp: "0",
        gf: "1",
        gr: "1",
        gm: "1",
    },
};

export const FINNIFTY_SPOT_OIX_CHART_DATA = {
    key: "FN Options Strike Spectrum Charts",
    name: "FN Options Strike Spectrum Charts",
    title: "FINNIFTY Options Strike Spectrum Charts",
    data: {
        chart_type: "lc",
        symbol: "FINNIFTY",
        type: "SINGLE",
        startDate: "",
        nDays: 4,
        prem: "fut",
        plot: "spt",
        fvol: "0",
        doix: "0",
        trp: "0",
        gf: "1",
        gr: "1",
        gm: "1",
    },
};

export const MIDCPNIFTY_SPOT_OIX_CHART_DATA = {
    key: "MN Options Strike Spectrum Charts",
    name: "MN Options Strike Spectrum Charts",
    title: "MIDCPNIFTY Options Strike Spectrum Charts",
    data: {
        chart_type: "lc",
        symbol: "MIDCPNIFTY",
        type: "SINGLE",
        startDate: "",
        nDays: 4,
        prem: "fut",
        plot: "spt",
        fvol: "0",
        doix: "0",
        trp: "0",
        gf: "1",
        gr: "1",
        gm: "1",
    },
};

export const SENSEX_SPOT_OIX_CHART_DATA = {
    key: "SNX Options Strike Spectrum Charts",
    name: "SNX Options Strike Spectrum Charts",
    title: "SENSEX Options Strike Spectrum Charts",
    data: {
        chart_type: "lc",
        symbol: "SENSEX",
        type: "SINGLE",
        startDate: "",
        nDays: 4,
        prem: "fut",
        plot: "spt",
        fvol: "0",
        doix: "0",
        trp: "0",
        gf: "1",
        gr: "1",
        gm: "1",
    },
};

export const NIFTY_ALLOPT_DOI_CHART_DATA = {
    key: "NF Options OI Change Charts",
    name: "NF Options OI Change Charts",
    title: "NIFTY Options OI Change Charts",
    data: {
        chart_type: "lc",
        symbol: "NIFTY",
        type: "SINGLE",
        startDate: "",
        nDays: 1,
        plot: "all_doi",
    },
};

export const BANKNIFTY_ALLOPT_DOI_CHART_DATA = {
    key: "BN Options OI Change Charts",
    name: "BN Options OI Change Charts",
    title: "BANKNIFTY Options OI Change Charts",
    data: {
        chart_type: "lc",
        symbol: "BANKNIFTY",
        type: "SINGLE",
        startDate: "",
        nDays: 1,
        plot: "all_doi",
    },
};

export const FINNIFTY_ALLOPT_DOI_CHART_DATA = {
    key: "FN Options OI Change Charts",
    name: "FN Options OI Change Charts",
    title: "FINNIFTY Options OI Change Charts",
    data: {
        chart_type: "lc",
        symbol: "FINNIFTY",
        type: "SINGLE",
        startDate: "",
        nDays: 1,
        plot: "all_doi",
    },
};

export const MIDCPNIFTY_ALLOPT_DOI_CHART_DATA = {
    key: "MN Options OI Change Charts",
    name: "MN Options OI Change Charts",
    title: "MIDCPNIFTY Options OI Change Charts",
    data: {
        chart_type: "lc",
        symbol: "MIDCPNIFTY",
        type: "SINGLE",
        startDate: "",
        nDays: 1,
        plot: "all_doi",
    },
};

export const SENSEX_ALLOPT_DOI_CHART_DATA = {
    key: "SNX Options OI Change Charts",
    name: "SNX Options OI Change Charts",
    title: "SENSEX Options OI Change Charts",
    data: {
        chart_type: "lc",
        symbol: "SENSEX",
        type: "SINGLE",
        startDate: "",
        nDays: 1,
        plot: "all_doi",
    },
};

export const NIFTY_ALLOPT_VOL_CHART_DATA = {
    key: "NF Options Volume Charts",
    name: "NF Options Volume Charts",
    title: "NIFTY Options Volume Charts",
    data: {
        chart_type: "lc",
        symbol: "NIFTY",
        type: "SINGLE",
        startDate: "",
        nDays: 1,
        plot: "all_vol",
    },
};

export const BANKNIFTY_ALLOPT_VOL_CHART_DATA = {
    key: "BN Options Volume Charts",
    name: "BN Options Volume Charts",
    title: "BANKNIFTY Options Volume Charts",
    data: {
        chart_type: "lc",
        symbol: "BANKNIFTY",
        type: "SINGLE",
        startDate: "",
        nDays: 1,
        plot: "all_vol",
    },
};

export const FINNIFTY_ALLOPT_VOL_CHART_DATA = {
    key: "FN Options Volume Charts",
    name: "FN Options Volume Charts",
    title: "FINNIFTY Options Volume Charts",
    data: {
        chart_type: "lc",
        symbol: "FINNIFTY",
        type: "SINGLE",
        startDate: "",
        nDays: 1,
        plot: "all_vol",
    },
};

export const MIDCPNIFTY_ALLOPT_VOL_CHART_DATA = {
    key: "MN Options Volume Charts",
    name: "MN Options Volume Charts",
    title: "MIDCPNIFTY Options Volume Charts",
    data: {
        chart_type: "lc",
        symbol: "MIDCPNIFTY",
        type: "SINGLE",
        startDate: "",
        nDays: 1,
        plot: "all_vol",
    },
};

export const SENSEX_ALLOPT_VOL_CHART_DATA = {
    key: "SNX Options Volume Charts",
    name: "SNX Options Volume Charts",
    title: "SENSEX Options Volume Charts",
    data: {
        chart_type: "lc",
        symbol: "SENSEX",
        type: "SINGLE",
        startDate: "",
        nDays: 1,
        plot: "all_vol",
    },
};

export const NIFTY_ALLOPT_DVOLX_CHART_DATA = {
    key: "NF Options NTM Volume Charts",
    name: "NF Options NTM Volume Charts",
    title: "NIFTY Options NTM Volume Charts",
    data: {
        chart_type: "lc",
        symbol: "NIFTY",
        type: "SINGLE",
        startDate: "",
        nDays: 1,
        plot: "all_dvolx",
    },
};

export const BANKNIFTY_ALLOPT_DVOLX_CHART_DATA = {
    key: "BN Options NTM Volume Charts",
    name: "BN Options NTM Volume Charts",
    title: "BANKNIFTY NTM Options Volume Charts",
    data: {
        chart_type: "lc",
        symbol: "BANKNIFTY",
        type: "SINGLE",
        startDate: "",
        nDays: 1,
        plot: "all_dvolx",
    },
};

export const FINNIFTY_ALLOPT_DVOLX_CHART_DATA = {
    key: "FN Options NTM Volume Charts",
    name: "FN Options NTM Volume Charts",
    title: "FINNIFTY Options NTM Volume Charts",
    data: {
        chart_type: "lc",
        symbol: "FINNIFTY",
        type: "SINGLE",
        startDate: "",
        nDays: 1,
        plot: "all_dvolx",
    },
};

export const MIDCPNIFTY_ALLOPT_DVOLX_CHART_DATA = {
    key: "MN Options NTM Volume Charts",
    name: "MN Options NTM Volume Charts",
    title: "MIDCPNIFTY Options NTM Volume Charts",
    data: {
        chart_type: "lc",
        symbol: "MIDCPNIFTY",
        type: "SINGLE",
        startDate: "",
        nDays: 1,
        plot: "all_dvolx",
    },
};

export const NIFTY_ALLOPT_VOLX_CHART_DATA = {
    key: "NF Options NTM Volx Charts",
    name: "NF Options NTM VolX™ Charts",
    title: "NIFTY Options NTM VolX™ Charts",
    data: {
        chart_type: "lc",
        symbol: "NIFTY",
        type: "SINGLE",
        startDate: "",
        nDays: 1,
        plot: "all_volx",
    },
};

export const BANKNIFTY_ALLOPT_VOLX_CHART_DATA = {
    key: "BN Options NTM Volx Charts",
    name: "BN Options NTM VolX™ Charts",
    title: "BANKNIFTY NTM Options VolX™ Charts",
    data: {
        chart_type: "lc",
        symbol: "BANKNIFTY",
        type: "SINGLE",
        startDate: "",
        nDays: 1,
        plot: "all_volx",
    },
};

export const FINNIFTY_ALLOPT_VOLX_CHART_DATA = {
    key: "FN Options NTM Volx Charts",
    name: "FN Options NTM VolX™ Charts",
    title: "FINNIFTY Options NTM VolX™ Charts",
    data: {
        chart_type: "lc",
        symbol: "FINNIFTY",
        type: "SINGLE",
        startDate: "",
        nDays: 1,
        plot: "all_volx",
    },
};

export const MIDCPNIFTY_ALLOPT_VOLX_CHART_DATA = {
    key: "MN Options NTM Volx Charts",
    name: "MN Options NTM VolX™ Charts",
    title: "MIDCPNIFTY Options NTM VolX™ Charts",
    data: {
        chart_type: "lc",
        symbol: "MIDCPNIFTY",
        type: "SINGLE",
        startDate: "",
        nDays: 1,
        plot: "all_volx",
    },
};

export const SENSEX_ALLOPT_VOLX_CHART_DATA = {
    key: "SNX Options NTM Volx Charts",
    name: "SNX Options NTM VolX™ Charts",
    title: "SENSEX Options NTM VolX™ Charts",
    data: {
        chart_type: "lc",
        symbol: "SENSEX",
        type: "SINGLE",
        startDate: "",
        nDays: 1,
        plot: "all_volx",
    },
};

export const NIFTY_ALLOPT_DOIX_CHART_DATA = {
    key: "NF Options NTM OI Change Charts",
    name: "NF Options NTM OI Change Charts",
    title: "NIFTY Options NTM OI Change Charts",
    data: {
        chart_type: "lc",
        symbol: "NIFTY",
        type: "SINGLE",
        startDate: "",
        nDays: 1,
        plot: "all_doix",
    },
};

export const BANKNIFTY_ALLOPT_DOIX_CHART_DATA = {
    key: "BN Options NTM OI Change Charts",
    name: "BN Options NTM OI Change Charts",
    title: "BANKNIFTY Options NTM OI Change Charts",
    data: {
        chart_type: "lc",
        symbol: "BANKNIFTY",
        type: "SINGLE",
        startDate: "",
        nDays: 1,
        plot: "all_doix",
    },
};

export const FINNIFTY_ALLOPT_DOIX_CHART_DATA = {
    key: "FN Options NTM OI Change Charts",
    name: "FN Options NTM OI Change Charts",
    title: "FINNIFTY Options NTM OI Change Charts",
    data: {
        chart_type: "lc",
        symbol: "FINNIFTY",
        type: "SINGLE",
        startDate: "",
        nDays: 1,
        plot: "all_doix",
    },
};

export const MIDCPNIFTY_ALLOPT_DOIX_CHART_DATA = {
    key: "MN Options NTM OI Change Charts",
    name: "MN Options NTM OI Change Charts",
    title: "MIDCPNIFTY Options NTM OI Change Charts",
    data: {
        chart_type: "lc",
        symbol: "MIDCPNIFTY",
        type: "SINGLE",
        startDate: "",
        nDays: 1,
        plot: "all_doix",
    },
};

export const SENSEX_ALLOPT_DOIX_CHART_DATA = {
    key: "SNX Options NTM OI Change Charts",
    name: "SNX Options NTM OI Change Charts",
    title: "SENSEX Options NTM OI Change Charts",
    data: {
        chart_type: "lc",
        symbol: "SENSEX",
        type: "SINGLE",
        startDate: "",
        nDays: 1,
        plot: "all_doix",
    },
};

export const NIFTY_FUTURES_OIX_CHART_DATA = {
    key: "NF Futures mViz Charts",
    name: "NF Futures mViz Charts",
    title: "NIFTY Futures mViz Charts",
    data: {
        chart_type: "lc",
        symbol: "NIFTY",
        type: "SINGLE",
        startDate: "",
        nDays: 1,
        prem: "bias",
        plot: "fut",
        doix: "1",
        gf: "1",
        trp: "1",
        fvol: "1",
    },
};

export const BANKNIFTY_FUTURES_OIX_CHART_DATA = {
    key: "BN Futures mViz Charts",
    name: "BN Futures mViz Charts",
    title: "BANKNIFTY Futures mViz Charts",
    data: {
        chart_type: "lc",
        symbol: "BANKNIFTY",
        type: "SINGLE",
        startDate: "",
        nDays: 1,
        prem: "bias",
        plot: "fut",
        doix: "1",
        gf: "1",
        trp: "1",
        fvol: "1",
    },
};

export const NIFTY_HV_CHART_DATA = {
    key: "NF HV Charts",
    name: "NF HV Charts",
    title: "NIFTY HV Charts",
    data: {
        chart_type: "hv",
        symbol: "NIFTY",
    },
};

export const BANKNIFTY_HV_CHART_DATA = {
    key: "BN HV Charts",
    name: "BN HV Charts",
    title: "BankNifty HV Charts",
    data: {
        chart_type: "hv",
        symbol: "BANKNIFTY",
    },
};

export const NIFTY_GCASH_BAR_CHART_DATA = {
    key: "NF Options Strikewise Gamma Charts",
    name: "NF Options Strikewise Gamma Charts",
    title: "NIFTY Options Strikewise Gamma Charts",
    data: {
        chart_type: "bc",
        symbol: "NIFTY",
        plot: "_igex",
        menu_type: "inventory",
    },
};

export const BANKNIFTY_GCASH_BAR_CHART_DATA = {
    key: "BN Options Strikewise Gamma Charts",
    name: "BN Options Strikewise Gamma Charts",
    title: "BANKNIFTY Options Strikewise Gamma Charts",
    data: {
        chart_type: "bc",
        symbol: "BANKNIFTY",
        plot: "_igex",
        menu_type: "inventory",
    },
};

export const SENSEX_GCASH_BAR_CHART_DATA = {
    key: "SNX Options Strikewise Gamma Charts",
    name: "SNX Options Strikewise Gamma Charts",
    title: "SENSEX Options Strikewise Gamma Charts",
    data: {
        chart_type: "bc",
        symbol: "SENSEX",
        plot: "_igex",
        menu_type: "inventory",
    },
};

export const FINNIFTY_GCASH_BAR_CHART_DATA = {
    key: "FN Options Strikewise Gamma Charts",
    name: "FN Options Strikewise Gamma Charts",
    title: "FINNIFTY Options Strikewise Gamma Charts",
    data: {
        chart_type: "bc",
        symbol: "FINNIFTY",
        plot: "_igex",
        menu_type: "inventory",
    },
};

export const MIDCPNIFTY_GCASH_BAR_CHART_DATA = {
    key: "MN Options Strikewise Gamma Charts",
    name: "MN Options Strikewise Gamma Charts",
    title: "MIDCPNIFTY Options Strikewise Gamma Charts",
    data: {
        chart_type: "bc",
        symbol: "MIDCPNIFTY",
        plot: "_igex",
        menu_type: "inventory",
    },
};

export const NIFTY_GAMMA_DENSITY_LINE_CHART_DATA = {
    key: "NF Options Gamma Density",
    name: "NF Options Gamma Density",
    title: "NIFTY Options GammaDensity",
    data: {
        chart_type: "bc",
        symbol: "NIFTY",
        plot: "gd_curves",
        menu_type: "inventory",
    },
};

export const BANKNIFTY_GAMMA_DENSITY_LINE_CHART_DATA = {
    key: "BN Options Gamma Density",
    name: "BN Options Gamma Density",
    title: "BANKNIFTY Options Gamma Density",
    data: {
        chart_type: "bc",
        symbol: "BANKNIFTY",
        plot: "gd_curves",
        menu_type: "inventory",
    },
};

export const FINNIFTY_GAMMA_DENSITY_LINE_CHART_DATA = {
    key: "FN Options Gamma Density",
    name: "FN Options Gamma Density",
    title: "FINNIFTY Options Gamma Density",
    data: {
        chart_type: "bc",
        symbol: "FINNIFTY",
        plot: "gd_curves",
        menu_type: "inventory",
    },
};

export const MIDCPNIFTY_GAMMA_DENSITY_LINE_CHART_DATA = {
    key: "MN Options Gamma Density",
    name: "MN Options Gamma Density",
    title: "MIDCPNIFTY Options Gamma Density",
    data: {
        chart_type: "bc",
        symbol: "MIDCPNIFTY",
        plot: "gd_curves",
        menu_type: "inventory",
    },
};

export const SENSEX_GAMMA_DENSITY_LINE_CHART_DATA = {
    key: "SNX Options Gamma Density",
    name: "SNX Options Gamma Density",
    title: "SENSEX Options Gamma Density",
    data: {
        chart_type: "bc",
        symbol: "SENSEX",
        plot: "gd_curves",
        menu_type: "inventory",
    },
};

export const NIFTY_GAMMA_CURVES_LINE_CHART_DATA = {
    key: "NF Options Gamma Exposure",
    name: "NF Options Gamma Exposure",
    title: "NIFTY Options Gamma Exposure",
    data: {
        chart_type: "bc",
        symbol: "NIFTY",
        plot: "gamma_curves",
        menu_type: "inventory",
    },
};

export const BANKNIFTY_GAMMA_CURVES_LINE_CHART_DATA = {
    key: "BN Options Gamma Exposure",
    name: "BN Options Gamma Exposure",
    title: "BANKNIFTY Options Gamma Exposure",
    data: {
        chart_type: "bc",
        symbol: "BANKNIFTY",
        plot: "gamma_curves",
        menu_type: "inventory",
    },
};

export const FINNIFTY_GAMMA_CURVES_LINE_CHART_DATA = {
    key: "FN Options Gamma Exposure",
    name: "FN Options Gamma Exposure",
    title: "FINNIFTY Options Gamma Exposure",
    data: {
        chart_type: "bc",
        symbol: "FINNIFTY",
        plot: "gamma_curves",
        menu_type: "inventory",
    },
};

export const MIDCPNIFTY_GAMMA_CURVES_LINE_CHART_DATA = {
    key: "MN Options Gamma Exposure",
    name: "MN Options Gamma Exposure",
    title: "MIDCPNIFTY Options Gamma Exposure",
    data: {
        chart_type: "bc",
        symbol: "MIDCPNIFTY",
        plot: "gamma_curves",
        menu_type: "inventory",
    },
};

export const SENSEX_GAMMA_CURVES_LINE_CHART_DATA = {
    key: "SNX Options Gamma Exposure",
    name: "SNX Options Gamma Exposure",
    title: "SENSEX Options Gamma Exposure",
    data: {
        chart_type: "bc",
        symbol: "SENSEX",
        plot: "gamma_curves",
        menu_type: "inventory",
    },
};

export const NIFTY_WCASH_BAR_CHART_DATA = {
    key: "NF Options Strikewise Wcash Charts",
    name: "NF Options Strikewise WCash™ Charts",
    title: "NIFTY Options Strikewise WCash™ Charts",
    data: {
        chart_type: "bc",
        symbol: "NIFTY",
        plot: "_wcash",
        menu_type: "inventory",
    },
};

export const BANKNIFTY_WCASH_BAR_CHART_DATA = {
    key: "BN Options Strikewise Wcash Charts",
    name: "BN Options Strikewise WCash™ Charts",
    title: "BANKNIFTY Options Strikewise WCash™ Charts",
    data: {
        chart_type: "bc",
        symbol: "BANKNIFTY",
        plot: "_wcash",
        menu_type: "inventory",
    },
};

export const FINNIFTY_WCASH_BAR_CHART_DATA = {
    key: "FN Options Strikewise Wcash Charts",
    name: "FN Options Strikewise WCash™ Charts",
    title: "FINNIFTY Options Strikewise WCash™ Charts",
    data: {
        chart_type: "bc",
        symbol: "FINNIFTY",
        plot: "_wcash",
        menu_type: "inventory",
    },
};

export const MIDCPNIFTY_WCASH_BAR_CHART_DATA = {
    key: "MN Options Strikewise Wcash Charts",
    name: "MN Options Strikewise WCash™ Charts",
    title: "MIDCPNIFTY Options Strikewise WCash™ Charts",
    data: {
        chart_type: "bc",
        symbol: "MIDCPNIFTY",
        plot: "_wcash",
        menu_type: "inventory",
    },
};

export const SENSEX_WCASH_BAR_CHART_DATA = {
    key: "SNX Options Strikewise Wcash Charts",
    name: "SNX Options Strikewise WCash™ Charts",
    title: "SENSEX Options Strikewise WCash™ Charts",
    data: {
        chart_type: "bc",
        symbol: "SENSEX",
        plot: "_wcash",
        menu_type: "inventory",
    },
};

export const NIFTY_OI_BAR_CHART_DATA = {
    key: "NF Options Strikewise oiViz Charts",
    name: "NF Options Strikewise oiViz Charts",
    title: "NIFTY Options Strikewise oiViz Charts",
    data: {
        chart_type: "bc",
        symbol: "NIFTY",
        plot: "_oi",
        menu_type: "oi",
    },
};

export const BANKNIFTY_OI_BAR_CHART_DATA = {
    key: "BN Options Strikewise oiViz Charts",
    name: "BN Options Strikewise oiViz Charts",
    title: "BANKNIFTY Options Strikewise oiViz Charts",
    data: {
        chart_type: "bc",
        symbol: "BANKNIFTY",
        plot: "_oi",
        menu_type: "oi",
    },
};

export const FINNIFTY_OI_BAR_CHART_DATA = {
    key: "FN Options Strikewise oiViz Charts",
    name: "FN Options Strikewise oiViz Charts",
    title: "FINNIFTY Options Strikewise oiViz Charts",
    data: {
        chart_type: "bc",
        symbol: "FINNIFTY",
        plot: "_oi",
        menu_type: "oi",
    },
};

export const MIDCPNIFTY_OI_BAR_CHART_DATA = {
    key: "MN Options Strikewise oiViz Charts",
    name: "MN Options Strikewise oiViz Charts",
    title: "MIDCPNIFTY Options Strikewise oiViz Charts",
    data: {
        chart_type: "bc",
        symbol: "MIDCPNIFTY",
        plot: "_oi",
        menu_type: "oi",
    },
};

export const SENSEX_OI_BAR_CHART_DATA = {
    key: "SNX Options Strikewise oiViz Charts",
    name: "SNX Options Strikewise oiViz Charts",
    title: "SENSEX Options Strikewise oiViz Charts",
    data: {
        chart_type: "bc",
        symbol: "SENSEX",
        plot: "_oi",
        menu_type: "oi",
    },
};

export const NIFTY_IV_CHART_DATA = {
    key: "NF IV Curve Charts",
    name: "NF IV Curve Charts",
    title: "NIFTY IV Curve Charts",
    data: {
        chart_type: "bc",
        symbol: "NIFTY",
        plot: "iv",
        menu_type: "oi",
    },
};

export const BANKNIFTY_IV_CHART_DATA = {
    key: "BN IV Curve Charts",
    name: "BN IV Curve Charts",
    title: "BANKNIFTY IV Curve Charts",
    data: {
        chart_type: "bc",
        symbol: "BANKNIFTY",
        plot: "iv",
        menu_type: "oi",
    },
};

export const SENSEX_IV_CHART_DATA = {
    key: "SNX IV Curve Charts",
    name: "SNX IV Curve Charts",
    title: "SENSEX IV Curve Charts",
    data: {
        chart_type: "bc",
        symbol: "SENSEX",
        plot: "iv",
        menu_type: "oi",
    },
};

export const NIFTY_SNAKE_CHART_DATA = {
    key: "NF Options Snake Charts",
    name: "NF Options Snake Charts",
    title: "NIFTY Options Snake Charts",
    data: {
        chart_type: "lc",
        symbol: "NIFTY",
        type: "SNAKES",
        plot: "oi",
    },
};

export const BANKNIFTY_SNAKE_CHART_DATA = {
    key: "BN Options Snake Charts",
    name: "BN Options Snake Charts",
    title: "BANKNIFTY Options Snake Charts",
    data: {
        chart_type: "lc",
        symbol: "BANKNIFTY",
        type: "SNAKES",
        plot: "oi",
    },
};

export const FINNIFTY_SNAKE_CHART_DATA = {
    key: "FN Options Snake Charts",
    name: "FN Options Snake Charts",
    title: "FINNIFTY Options Snake Charts",
    data: {
        chart_type: "lc",
        symbol: "FINNIFTY",
        type: "SNAKES",
        plot: "oi",
    },
};

export const MIDCPNIFTY_SNAKE_CHART_DATA = {
    key: "MN Options Snake Charts",
    name: "MN Options Snake Charts",
    title: "MIDCPNIFTY Options Snake Charts",
    data: {
        chart_type: "lc",
        symbol: "MIDCPNIFTY",
        type: "SNAKES",
        plot: "oi",
    },
};

export const SENSEX_SNAKE_CHART_DATA = {
    key: "SNX Options Snake Charts",
    name: "SNX Options Snake Charts",
    title: "SENSEX Options Snake Charts",
    data: {
        chart_type: "lc",
        symbol: "SENSEX",
        type: "SNAKES",
        plot: "oi",
    },
};

const BROKER_LOGIN_COMPONENT = {
    name: "Broker Integration",
    route: undefined,
    isBrokerPopup: true,
    roles: ALLOWED_ROLES_PRO2,
};

const ECOURSE_COMPONENT = {
    name: "ECourse Subscription",
    route: undefined,
    isECoursePopup: true,
    roles: ALLOWED_ROLES_ALL,
};

const MP_CHART_COMP = {
    name: "Market Profile",
    title: "Visualize market structure and price distribution.",
    route: "/market-profile",
    component: <MarketProfileCharts />,
    roles: ALLOWED_ROLES_ALL,
};

const MP_ADV_CHART_COMP = {
    name: "Advanced Market Profile",
    title: "Visualize market structure and price distribution.",
    route: "/market-profile",
    component: <MarketProfileCharts />,
    roles: ALLOWED_ROLES_PREMIUM,
};

const OF_CHART_COMP = {
    name: "Vtrender™ Orderflow",
    title: "Track real time market activity instantly.",
    route: "/orderflow",
    component: <OrderflowCharts />,
    roles: ALLOWED_ROLES_ELITE, // Updated: Elite tier only (pro1 role)
    resources: RESOURCE_LIST.ORDERFLOW,
};

const OF_REPLAY_COMP = {
    name: "Orderflow Replay",
    title: "Replay historical Orderflow charts at variable speeds for post-market analysis.",
    route: "/orderflow?mode=replay",
    component: <OrderflowCharts />,
    roles: ALLOWED_ROLES_ELITE,
    resources: RESOURCE_LIST.ORDERFLOW,
};
export const IV_RANGE_CHART_DATA = {
    name: "Vtrender™ IV Range",
    title: "Implied-volatility range visualization with live session updates.",
    open: false,
    items: [
        {
            name: "NIFTY",
            route: "/NF_iv-range",
            component: (
                <LineChartMainNew
                    id="nIvRangeChart"
                    stateData={NIFTY_IV_RANGE_CHART_DATA}
                />
            ),
            stateData: NIFTY_IV_RANGE_CHART_DATA,
            roles: ALLOWED_ROLES_ELITE,
        },
        {
            name: "SENSEX",
            route: "/SNX_iv-range",
            component: (
                <LineChartMainNew
                    id="snxIvRangeChart"
                    stateData={SENSEX_IV_RANGE_CHART_DATA}
                />
            ),
            stateData: SENSEX_IV_RANGE_CHART_DATA,
            roles: ALLOWED_ROLES_ELITE,
        },
    ],
};
const LINE_CHART_COMP = {
    name: "Line Charts",
    title: "Line Charts with Market Profile insights.",
    route: "/line-chart",
    component: <LineChartMain />,
    roles: ALLOWED_ROLES_PREMIUM,
};

const LINE_CHART_COMP_NEW = {
    name: "Smart Candlesticks™",
    title: "Enhanced Candlesticks with Market Profile and Orderflow insights.",
    route: "/candle-line-chart",
    component: <LineChartMainNew />,
    roles: ALLOWED_ROLES_ELITE, // Updated: Elite tier only (pro1 role)
    resources: RESOURCE_LIST.ORDERFLOW, // Updated: Requires orderflow, not tbt_data (tbt_data only for polling speed)
};

// const CANLDE_CHART_COMP= {
//   name: "Candlestick Charts",
//   route: "/candle",
//   component: <CandlestickCharts/>,
//   roles:ALLOWED_ROLES_ELITE
// }

const NIFTY_SPOT_OIX_CHART_COMP = {
    name: "NF Options Strike Spectrum Charts",
    // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&prem=fut&plot=spt&gf=1&gr=1&gm=1",
    route: "/line-chart/NF_Options_Strike_Spectrum_Charts",
    component: (
        <LineChart
            id="nspotOixLineChart"
            stateData={NIFTY_SPOT_OIX_CHART_DATA}
        />
    ),
    stateData: NIFTY_SPOT_OIX_CHART_DATA,
    roles: ALLOWED_ROLES_PREMIUM,
};

const BANKNIFTY_SPOT_OIX_CHART_COMP = {
    name: "BN Options Strike Spectrum Charts",
    // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&prem=fut&plot=spt&gf=1&gr=1&gm=1",
    route: "/line-chart/BN_Options_Strike_Spectrum_Charts",
    component: <LineChart id="bnspotOixLineChart" />,
    stateData: BANKNIFTY_SPOT_OIX_CHART_DATA,
    roles: ALLOWED_ROLES_PREMIUM,
};

const FINNIFTY_SPOT_OIX_CHART_COMP = {
    name: "FN Options Strike Spectrum Charts",
    // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&prem=fut&plot=spt&gf=1&gr=1&gm=1",
    route: "/line-chart/FN_Options_Strike_Spectrum_Charts",
    component: <LineChart id="fnspotOixLineChart" />,
    stateData: FINNIFTY_SPOT_OIX_CHART_DATA,
    roles: ALLOWED_ROLES_PREMIUM,
};

export const SPOT_OIX_CHART_DATA = {
    name: "Spectrum",
    title: "Gamma-based Options inventory Range Visualization.",
    open: false,
    items: [
        {
            name: "NIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&prem=fut&plot=spt&gf=1&gr=1&gm=1",
            route: "/line-chart/NF_Options_Strike_Spectrum_Charts",
            component: (
                <LineChart
                    id="nspotOixLineChart"
                    stateData={NIFTY_SPOT_OIX_CHART_DATA}
                />
            ),
            stateData: NIFTY_SPOT_OIX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "BANKNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&prem=fut&plot=spt&gf=1&gr=1&gm=1",
            route: "/line-chart/BN_Options_Strike_Spectrum_Charts",
            component: <LineChart id="bnspotOixLineChart" />,
            stateData: BANKNIFTY_SPOT_OIX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "FINNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&prem=fut&plot=spt&gf=1&gr=1&gm=1",
            route: "/line-chart/FN_Options_Strike_Spectrum_Charts",
            component: <LineChart id="fnspotOixLineChart" />,
            stateData: FINNIFTY_SPOT_OIX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "MIDCPNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&prem=fut&plot=spt&gf=1&gr=1&gm=1",
            route: "/line-chart/MN_Options_Strike_Spectrum_Charts",
            component: <LineChart id="mnspotOixLineChart" />,
            stateData: MIDCPNIFTY_SPOT_OIX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
    ],
};

export const SPOT_OIX_CHART_DATA_NEW = {
    name: "Vtrender™ Spectrum",
    title: "Gamma-based Options inventory Range Visualization.",
    open: false,
    items: [
        {
            name: "NIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&prem=fut&plot=spt&gf=1&gr=1&gm=1",
            route: "/candle-line-chart/NF_Options_Strike_Spectrum_Charts",
            component: (
                <LineChartNew
                    id="nspotOixLineChart"
                    stateData={NIFTY_SPOT_OIX_CHART_DATA}
                />
            ),
            stateData: NIFTY_SPOT_OIX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "BANKNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&prem=fut&plot=spt&gf=1&gr=1&gm=1",
            route: "/candle-line-chart/BN_Options_Strike_Spectrum_Charts",
            component: <LineChartNew id="bnspotOixLineChart" />,
            stateData: BANKNIFTY_SPOT_OIX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "FINNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&prem=fut&plot=spt&gf=1&gr=1&gm=1",
            route: "/candle-line-chart/FN_Options_Strike_Spectrum_Charts",
            component: <LineChartNew id="fnspotOixLineChart" />,
            stateData: FINNIFTY_SPOT_OIX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "MIDCPNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&prem=fut&plot=spt&gf=1&gr=1&gm=1",
            route: "/candle-line-chart/MN_Options_Strike_Spectrum_Charts",
            component: <LineChartNew id="mnspotOixLineChart" />,
            stateData: MIDCPNIFTY_SPOT_OIX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "SENSEX",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&prem=fut&plot=spt&gf=1&gr=1&gm=1",
            route: "/candle-line-chart/SNX_Options_Strike_Spectrum_Charts",
            component: <LineChartNew id="snxspotOixLineChart" />,
            stateData: SENSEX_SPOT_OIX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
    ],
};

const NIFTY_ALLOPT_DOI_CHART_COMP = {
    name: "NF Options OI Change Charts",
    // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doi",
    route: "/line-chart/NF_Options_OI_Change_Charts",
    component: <LineChart id="nAllOptDoiLineChart" />,
    stateData: NIFTY_ALLOPT_DOI_CHART_DATA,
    roles: ALLOWED_ROLES_PREMIUM,
};

const BANKNIFTY_ALLOPT_DOI_CHART_COMP = {
    name: "BN Options OI Change Charts",
    // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doi",
    route: "/line-chart/BN_Options_OI_Change_Charts",
    component: <LineChart id="bnAllOptDoiLineChart" />,
    stateData: BANKNIFTY_ALLOPT_DOI_CHART_DATA,
    roles: ALLOWED_ROLES_PREMIUM,
};

const FINNIFTY_ALLOPT_DOI_CHART_COMP = {
    name: "FN Options OI Change Charts",
    // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doi",
    route: "/line-chart/FN_Options_OI_Change_Charts",
    component: <LineChart id="fnAllOptDoiLineChart" />,
    stateData: FINNIFTY_ALLOPT_DOI_CHART_DATA,
    roles: ALLOWED_ROLES_PREMIUM,
};

export const ALLOPT_DOI_CHART_DATA = {
    name: "Total OI",
    open: false,
    items: [
        {
            name: "NIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/line-chart/NF_Options_OI_Change_Charts",
            component: <LineChart id="nAllOptDoiLineChart" />,
            stateData: NIFTY_ALLOPT_DOI_CHART_DATA,
            roles: ALLOWED_ROLES_ALL, // Updated: Free tier access
        },
        {
            name: "BANKNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/line-chart/BN_Options_OI_Change_Charts",
            component: <LineChart id="bnAllOptDoiLineChart" />,
            stateData: BANKNIFTY_ALLOPT_DOI_CHART_DATA,
            roles: ALLOWED_ROLES_ALL, // Updated: Free tier access
        },
        {
            name: "FINNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/line-chart/FN_Options_OI_Change_Charts",
            component: <LineChart id="fnAllOptDoiLineChart" />,
            stateData: FINNIFTY_ALLOPT_DOI_CHART_DATA,
            roles: ALLOWED_ROLES_ALL, // Updated: Free tier access
        },
        {
            name: "MIDCPNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/line-chart/MN_Options_OI_Change_Charts",
            component: <LineChart id="mnAllOptDoiLineChart" />,
            stateData: MIDCPNIFTY_ALLOPT_DOI_CHART_DATA,
            roles: ALLOWED_ROLES_ALL, // Updated: Free tier access
        },
        {
            name: "SENSEX",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/line-chart/SNX_Options_OI_Change_Charts",
            component: <LineChart id="snxAllOptDoiLineChart" />,
            stateData: SENSEX_ALLOPT_DOI_CHART_DATA,
            roles: ALLOWED_ROLES_ALL, // Updated: Free tier access
        },
    ],
};

export const ALLOPT_DOI_CHART_DATA_NEW = {
    name: "Total OI",
    title: "Unlock market insights with comprehensive open interest data.",
    open: false,
    items: [
        {
            name: "NIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/candle-line-chart/NF_Options_OI_Change_Charts",
            component: <LineChartNew id="nAllOptDoiLineChart" />,
            stateData: NIFTY_ALLOPT_DOI_CHART_DATA,
            roles: ALLOWED_ROLES_ALL,
        },
        {
            name: "BANKNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/candle-line-chart/BN_Options_OI_Change_Charts",
            component: <LineChartNew id="bnAllOptDoiLineChart" />,
            stateData: BANKNIFTY_ALLOPT_DOI_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "FINNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/candle-line-chart/FN_Options_OI_Change_Charts",
            component: <LineChartNew id="fnAllOptDoiLineChart" />,
            stateData: FINNIFTY_ALLOPT_DOI_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "MIDCPNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/candle-line-chart/MN_Options_OI_Change_Charts",
            component: <LineChartNew id="mnAllOptDoiLineChart" />,
            stateData: MIDCPNIFTY_ALLOPT_DOI_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "SENSEX",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/candle-line-chart/SNX_Options_OI_Change_Charts",
            component: <LineChart id="snxAllOptDoiLineChart" />,
            stateData: SENSEX_ALLOPT_DOI_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM, // Updated: Free tier access
        },
    ],
};

export const ALLOPT_VOL_CHART_DATA = {
    name: "Total Volumes",
    title: "Discover market trends with comprehensive volume analysis.",
    open: false,
    items: [
        {
            name: "NIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/line-chart/NF_Options_Vol_Charts",
            component: <LineChart id="nAllOptVolLineChart" />,
            stateData: NIFTY_ALLOPT_VOL_CHART_DATA,
            roles: ALLOWED_ROLES_ALL, // Updated: Free tier access
        },
        {
            name: "BANKNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/line-chart/BN_Options_Vol_Charts",
            component: <LineChart id="bnAllOptVolLineChart" />,
            stateData: BANKNIFTY_ALLOPT_VOL_CHART_DATA,
            roles: ALLOWED_ROLES_ALL, // Updated: Free tier access
        },
        {
            name: "FINNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/line-chart/FN_Options_Vol_Charts",
            component: <LineChart id="fnAllOptVolLineChart" />,
            stateData: FINNIFTY_ALLOPT_VOL_CHART_DATA,
            roles: ALLOWED_ROLES_ALL, // Updated: Free tier access
        },
        {
            name: "MIDCPNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/line-chart/MN_Options_Vol_Charts",
            component: <LineChart id="mnAllOptVolLineChart" />,
            stateData: MIDCPNIFTY_ALLOPT_VOL_CHART_DATA,
            roles: ALLOWED_ROLES_ALL, // Updated: Free tier access
        },
        {
            name: "SENSEX",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/line-chart/SNX_Options_Vol_Charts",
            component: <LineChart id="snxAllOptVolLineChart" />,
            stateData: SENSEX_ALLOPT_VOL_CHART_DATA,
            roles: ALLOWED_ROLES_ALL, // Updated: Free tier access
        },
    ],
};

export const ALLOPT_VOL_CHART_DATA_NEW = {
    name: "Total Volumes",
    title: "Discover market trends with comprehensive volume analysis.",
    open: false,
    items: [
        {
            name: "NIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/candle-line-chart/NF_Options_Vol_Charts",
            component: <LineChartNew id="nAllOptVolLineChart" />,
            stateData: NIFTY_ALLOPT_VOL_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "BANKNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/candle-line-chart/BN_Options_Vol_Charts",
            component: <LineChartNew id="bnAllOptVolLineChart" />,
            stateData: BANKNIFTY_ALLOPT_VOL_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "FINNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/candle-line-chart/FN_Options_Vol_Charts",
            component: <LineChartNew id="fnAllOptVolLineChart" />,
            stateData: FINNIFTY_ALLOPT_VOL_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "MIDCPNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/candle-line-chart/MN_Options_Vol_Charts",
            component: <LineChartNew id="mnAllOptVolLineChart" />,
            stateData: MIDCPNIFTY_ALLOPT_VOL_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "SENSEX",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/candle-line-chart/SNX_Options_Vol_Charts",
            component: <LineChartNew id="snxAllOptVolLineChart" />,
            stateData: SENSEX_ALLOPT_VOL_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
    ],
};
export const ALLOPT_DVOLX_CHART_DATA = {
    name: "Options NTM Volume Charts",
    title: "Near-the-Money options inventory Volume Indicator.",
    open: false,
    items: [
        {
            name: "NIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/line-chart/NF_Options_NTM_Vol_Charts",
            component: <LineChart id="nAllOptNtmVolLineChart" />,
            stateData: NIFTY_ALLOPT_DVOLX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "BANKNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/line-chart/BN_Options_NTM_Vol_Charts",
            component: <LineChart id="bnAllOptNtmVolLineChart" />,
            stateData: BANKNIFTY_ALLOPT_DVOLX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "FINNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/line-chart/FN_Options_NTM_Vol_Charts",
            component: <LineChart id="fnAllNtmOptVolLineChart" />,
            stateData: FINNIFTY_ALLOPT_DVOLX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "MIDCPNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/line-chart/MN_Options_NTM_Vol_Charts",
            component: <LineChart id="mnAllOptNtmVolLineChart" />,
            stateData: MIDCPNIFTY_ALLOPT_DVOLX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
    ],
};

export const ALLOPT_DVOLX_CHART_DATA_NEW = {
    name: "Options NTM Volume Charts",
    title: "Near-the-Money options inventory Volume Indicator.",
    open: false,
    items: [
        {
            name: "NIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/candle-line-chart/NF_Options_NTM_Vol_Charts",
            component: <LineChartNew id="nAllOptNtmVolLineChart" />,
            stateData: NIFTY_ALLOPT_DVOLX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "BANKNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/candle-line-chart/BN_Options_NTM_Vol_Charts",
            component: <LineChartNew id="bnAllOptNtmVolLineChart" />,
            stateData: BANKNIFTY_ALLOPT_DVOLX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "FINNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/candle-line-chart/FN_Options_NTM_Vol_Charts",
            component: <LineChartNew id="fnAllNtmOptVolLineChart" />,
            stateData: FINNIFTY_ALLOPT_DVOLX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "MIDCPNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/candle-line-chart/MN_Options_NTM_Vol_Charts",
            component: <LineChartNew id="mnAllOptNtmVolLineChart" />,
            stateData: MIDCPNIFTY_ALLOPT_DVOLX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
    ],
};

export const ALLOPT_VOLX_CHART_DATA = {
    name: "NTM VolX™",
    title: "Near-the-Money options inventory Volume Indicator.",
    open: false,
    items: [
        {
            name: "NIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/line-chart/NF_Options_NTM_Volx_Charts",
            component: <LineChart id="nAllOptNtmVolxLineChart" />,
            stateData: NIFTY_ALLOPT_VOLX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "BANKNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/line-chart/BN_Options_NTM_Volx_Charts",
            component: <LineChart id="bnAllOptNtmVolxLineChart" />,
            stateData: BANKNIFTY_ALLOPT_VOLX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "FINNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/line-chart/FN_Options_NTM_Volx_Charts",
            component: <LineChart id="fnAllNtmOptVolxLineChart" />,
            stateData: FINNIFTY_ALLOPT_VOLX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "MIDCPNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/line-chart/MN_Options_NTM_Volx_Charts",
            component: <LineChart id="mnAllOptNtmVolxLineChart" />,
            stateData: MIDCPNIFTY_ALLOPT_VOLX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "SENSEX",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/line-chart/SNX_Options_NTM_Volx_Charts",
            component: <LineChart id="snxAllOptNtmVolxLineChart" />,
            stateData: SENSEX_ALLOPT_VOLX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
    ],
};

export const ALLOPT_VOLX_CHART_DATA_NEW = {
    name: "Vtrender™ NTM VolX™",
    title: "Near-the-Money options inventory Smart Volume Indicator.",
    open: false,
    items: [
        {
            name: "NIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/candle-line-chart/NF_Options_NTM_Volx_Charts",
            component: <LineChartNew id="nAllOptNtmVolxLineChart" />,
            stateData: NIFTY_ALLOPT_VOLX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "BANKNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/candle-line-chart/BN_Options_NTM_Volx_Charts",
            component: <LineChartNew id="bnAllOptNtmVolxLineChart" />,
            stateData: BANKNIFTY_ALLOPT_VOLX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "FINNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/candle-line-chart/FN_Options_NTM_Volx_Charts",
            component: <LineChartNew id="fnAllNtmOptVolxLineChart" />,
            stateData: FINNIFTY_ALLOPT_VOLX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "MIDCPNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/candle-line-chart/MN_Options_NTM_Volx_Charts",
            component: <LineChartNew id="mnAllOptNtmVolxLineChart" />,
            stateData: MIDCPNIFTY_ALLOPT_VOLX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "SENSEX",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doi",
            route: "/candle-line-chart/SNX_Options_NTM_Volx_Charts",
            component: <LineChartNew id="snxAllOptNtmVolxLineChart" />,
            stateData: SENSEX_ALLOPT_VOLX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
    ],
};

const NIFTY_ALLOPT_DOIX_CHART_COMP = {
    name: "NF Options NTM OI Change Charts",
    // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doix",
    route: "/line-chart/NF_Options_NTM_OI_Change_Charts",
    component: <LineChart id="nAllOptDoixLineChart" />,
    stateData: NIFTY_ALLOPT_DOIX_CHART_DATA,
    roles: ALLOWED_ROLES_PREMIUM,
};

const BANKNIFTY_ALLOPT_DOIX_CHART_COMP = {
    name: "BN Options NTM OI Change Charts",
    // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
    route: "/line-chart/BN_Options_NTM_OI_Change_Charts",
    component: <LineChart id="bnAllOptDoixLineChart" />,
    stateData: BANKNIFTY_ALLOPT_DOIX_CHART_DATA,
    roles: ALLOWED_ROLES_PREMIUM,
};

const FINNIFTY_ALLOPT_DOIX_CHART_COMP = {
    name: "FN Options NTM OI Change Charts",
    // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
    route: "/line-chart/FN_Options_NTM_OI_Change_Charts",
    component: <LineChart id="fnAllOptDoixLineChart" />,
    stateData: FINNIFTY_ALLOPT_DOIX_CHART_DATA,
    roles: ALLOWED_ROLES_PREMIUM,
};

export const ALLOPT_DOIX_CHART_DATA = {
    name: "NTM OI",
    title: "Near-the-Money options inventory Open Interest Indicator.",
    open: false,
    items: [
        {
            name: "NIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/line-chart/NF_Options_NTM_OI_Change_Charts",
            component: <LineChart id="nAllOptDoixLineChart" />,
            stateData: NIFTY_ALLOPT_DOIX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "BANKNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/line-chart/BN_Options_NTM_OI_Change_Charts",
            component: <LineChart id="bnAllOptDoixLineChart" />,
            stateData: BANKNIFTY_ALLOPT_DOIX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "FINNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/line-chart/FN_Options_NTM_OI_Change_Charts",
            component: <LineChart id="fnAllOptDoixLineChart" />,
            stateData: FINNIFTY_ALLOPT_DOIX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "MIDCPNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/line-chart/MN_Options_NTM_OI_Change_Charts",
            component: <LineChart id="mnAllOptDoixLineChart" />,
            stateData: MIDCPNIFTY_ALLOPT_DOIX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
    ],
};

export const ALLOPT_DOIX_CHART_DATA_NEW = {
    name: "Vtrender™ NTM OI",
    title: "Near-the-Money options inventory Open Interest Indicator.",
    open: false,
    items: [
        {
            name: "NIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/candle-line-chart/NF_Options_NTM_OI_Change_Charts",
            component: <LineChartNew id="nAllOptDoixLineChart" />,
            stateData: NIFTY_ALLOPT_DOIX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "BANKNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/candle-line-chart/BN_Options_NTM_OI_Change_Charts",
            component: <LineChartNew id="bnAllOptDoixLineChart" />,
            stateData: BANKNIFTY_ALLOPT_DOIX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "FINNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/candle-line-chart/FN_Options_NTM_OI_Change_Charts",
            component: <LineChartNew id="fnAllOptDoixLineChart" />,
            stateData: FINNIFTY_ALLOPT_DOIX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "MIDCPNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/candle-line-chart/MN_Options_NTM_OI_Change_Charts",
            component: <LineChartNew id="mnAllOptDoixLineChart" />,
            stateData: MIDCPNIFTY_ALLOPT_DOIX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "SENSEX",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/candle-line-chart/SNX_Options_NTM_OI_Change_Charts",
            component: <LineChartNew id="snxAllOptDoixLineChart" />,
            stateData: SENSEX_ALLOPT_DOIX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
    ],
};

const NIFTY_FUTURES_OIX_CHART_COMP = {
    name: "NF Futures mViz Charts",
    // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&fvol=1&prem=bias&doix=1&plot=fut&gf=1&trp=1",
    route: "/line-chart/NF_Futures_MViz_Chart",
    component: <LineChart id="noixLineChart" />,
    stateData: NIFTY_FUTURES_OIX_CHART_DATA,
    roles: ALLOWED_ROLES_PREMIUM,
};

const BANKNIFTY_FUTURES_OIX_CHART_COMP = {
    name: "BN Futures mViz Charts",
    // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&fvol=1&prem=bias&doix=1&plot=fut&gf=1&trp=1",
    route: "/line-chart/BN_Futures_MViz_Chart",
    component: <LineChart id="bnoixLineChart" />,
    stateData: BANKNIFTY_FUTURES_OIX_CHART_DATA,
    roles: ALLOWED_ROLES_PREMIUM,
};

export const FUTURES_OIX_CHART_DATA = {
    name: "Futures mViz",
    open: false,
    items: [
        {
            name: "NIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/line-chart/NF_Futures_MViz_Chart",
            component: <LineChart id="noixLineChart" />,
            stateData: NIFTY_FUTURES_OIX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "BANKNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/line-chart/BN_Futures_MViz_Chart",
            component: <LineChart id="bnoixLineChart" />,
            stateData: BANKNIFTY_FUTURES_OIX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
    ],
};

export const FUTURES_OIX_CHART_DATA_NEW = {
    name: "Futures mViz",
    open: false,
    items: [
        {
            name: "NIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/candle-line-chart/NF_Futures_MViz_Chart",
            component: <LineChartNew id="noixLineChart" />,
            stateData: NIFTY_FUTURES_OIX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "BANKNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/candle-line-chart/BN_Futures_MViz_Chart",
            component: <LineChartNew id="bnoixLineChart" />,
            stateData: BANKNIFTY_FUTURES_OIX_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
    ],
};

const NIFTY_HV_CHART_COMP = {
    name: "NF HV Charts",
    // route: "/hv-stock-chart?symbol=NIFTY",
    route: "/hv-stock-chart/NIFTY",
    component: <StockChartHV id="nhv" />,
    stateData: NIFTY_HV_CHART_DATA,
    roles: ALLOWED_ROLES_PREMIUM,
};
const BANKNIFTY_HV_CHART_COMP = {
    name: "BN HV Charts",
    // route: "/hv-stock-chart?symbol=BANKNIFTY",
    route: "/hv-stock-chart/BANKNIFTY",
    component: <StockChartHV id="bnhv" />,
    stateData: BANKNIFTY_HV_CHART_DATA,
    roles: ALLOWED_ROLES_PREMIUM,
};

export const HV_CHART_DATA = {
    name: "HV",
    title: "Historical Volatility",
    open: false,
    items: [
        {
            name: "NIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/hv-stock-chart/NIFTY",
            component: <StockChartHV id="nhv" />,
            stateData: NIFTY_HV_CHART_DATA,
            roles: ALLOWED_ROLES_ALL, // Updated: Free tier access
        },
        {
            name: "BANKNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/hv-stock-chart/BANKNIFTY",
            component: <StockChartHV id="bnhv" />,
            stateData: BANKNIFTY_HV_CHART_DATA,
            roles: ALLOWED_ROLES_ALL, // Updated: Free tier access
        },
    ],
};
const NIFTY_GCASH_BAR_CHARTS_COMP = {
    name: "NF Options Strikewise Gamma Charts",
    // route: "/bar-chart?symbol=NIFTY&plot=net_gcash",
    route: "/bar-chart/NIFTY_Strike_Value",
    component: <BarChart id="nbarsv" />,
    stateData: NIFTY_GCASH_BAR_CHART_DATA,
    roles: ALLOWED_ROLES_PREMIUM,
};

const BANKNIFTY_GCASH_BAR_CHARTS_COMP = {
    name: "BN Options Strikewise Gamma Charts",
    // route: "/bar-chart?symbol=BANKNIFTY&plot=net_gcash",
    route: "/bar-chart/BANKNIFTY_Strike_Value",
    component: <BarChart id="bnbarsv" />,
    stateData: BANKNIFTY_GCASH_BAR_CHART_DATA,
    roles: ALLOWED_ROLES_PREMIUM,
};

const FINNIFTY_GCASH_BAR_CHARTS_COMP = {
    name: "FN Options Strikewise Gamma Charts",
    // route: "/bar-chart?symbol=BANKNIFTY&plot=net_gcash",
    route: "/bar-chart/FINNIFTY_Strike_Value",
    component: <BarChart id="bnbarsv" />,
    stateData: FINNIFTY_GCASH_BAR_CHART_DATA,
    roles: ALLOWED_ROLES_PREMIUM,
};

export const GCASH_BAR_CHARTS_DATA = {
    name: "Gamma",
    title: "Gamma Exposure Analysis.",
    open: false,
    items: [
        {
            name: "NIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/bar-chart/NIFTY_Strike_Value",
            component: <BarChart id="nbarsv" />,
            stateData: NIFTY_GCASH_BAR_CHART_DATA,
            roles: ALLOWED_ROLES_ELITE,
        },
        {
            name: "BANKNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/bar-chart/BANKNIFTY_Strike_Value",
            component: <BarChart id="bnbarsv" />,
            stateData: BANKNIFTY_GCASH_BAR_CHART_DATA,
            roles: ALLOWED_ROLES_ELITE,
        },
        {
            name: "FINNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/bar-chart/FINNIFTY_Strike_Value",
            component: <BarChart id="fnbarsv" />,
            stateData: FINNIFTY_GCASH_BAR_CHART_DATA,
            roles: ALLOWED_ROLES_ELITE,
        },
        {
            name: "MIDCPNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/bar-chart/MIDCPNIFTY_Strike_Value",
            component: <BarChart id="mnbarsv" />,
            stateData: MIDCPNIFTY_GCASH_BAR_CHART_DATA,
            roles: ALLOWED_ROLES_ELITE,
        },
    ],
};

export const WCASH_BAR_CHARTS_DATA = {
    name: "WCash™",
    title: "Writer's Cash gain Analysis.",
    open: false,
    items: [
        {
            name: "NIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/bar-chart/NIFTY_Strike_Wcash",
            component: <BarChart id="nbarsw" />,
            stateData: NIFTY_WCASH_BAR_CHART_DATA,
            roles: ALLOWED_ROLES_ALL,
        },
        {
            name: "BANKNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/bar-chart/BANKNIFTY_Strike_Wcash",
            component: <BarChart id="bnbarsw" />,
            stateData: BANKNIFTY_WCASH_BAR_CHART_DATA,
            roles: ALLOWED_ROLES_ALL,
        },
        {
            name: "FINNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/bar-chart/FINNIFTY_Strike_Wcash",
            component: <BarChart id="fnbarsw" />,
            stateData: FINNIFTY_WCASH_BAR_CHART_DATA,
            roles: ALLOWED_ROLES_ALL,
        },
        {
            name: "MIDCPNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/bar-chart/MIDCPNIFTY_Strike_Wcash",
            component: <BarChart id="mnbarsw" />,
            stateData: MIDCPNIFTY_WCASH_BAR_CHART_DATA,
            roles: ALLOWED_ROLES_ALL,
        },
        {
            name: "SENSEX",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/bar-chart/SENSEX_Strike_Wcash",
            component: <BarChart id="mnbarsw" />,
            stateData: SENSEX_WCASH_BAR_CHART_DATA,
            roles: ALLOWED_ROLES_ALL,
        },
    ],
};

export const GAMMA_DENSITY_LINE_DATA = {
    name: "Vtrender™ Gamma Density",
    title: "Gamma Density Analysis.",
    open: false,
    items: [
        {
            name: "NIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/bar-chart/NIFTY_Gamma_Density",
            component: <BarChart id="nlcsv" />,
            stateData: NIFTY_GAMMA_DENSITY_LINE_CHART_DATA,
            roles: ALLOWED_ROLES_ELITE, // Updated: Elite tier only
        },
        {
            name: "BANKNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/bar-chart/BANKNIFTY_Gamma_Density",
            component: <BarChart id="bnlcsv" />,
            stateData: BANKNIFTY_GAMMA_DENSITY_LINE_CHART_DATA,
            roles: ALLOWED_ROLES_ELITE, // Updated: Elite tier only
        },
        {
            name: "FINNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/bar-chart/FINNIFTY_Gamma_Density",
            component: <BarChart id="fnlcsv" />,
            stateData: FINNIFTY_GAMMA_DENSITY_LINE_CHART_DATA,
            roles: ALLOWED_ROLES_ELITE, // Updated: Elite tier only
        },
        {
            name: "MIDCPNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/bar-chart/MIDCPNIFTY_Gamma_Density",
            component: <BarChart id="mnlcsv" />,
            stateData: MIDCPNIFTY_GAMMA_DENSITY_LINE_CHART_DATA,
            roles: ALLOWED_ROLES_ELITE, // Updated: Elite tier only
        },
        {
            name: "SENSEX",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/bar-chart/SENSEX_Gamma_Density",
            component: <BarChart id="snxlcsv" />,
            stateData: SENSEX_GAMMA_DENSITY_LINE_CHART_DATA,
            roles: ALLOWED_ROLES_ELITE, // Updated: Elite tier only
        },
    ],
};

export const GAMMA_CURVES_LINE_DATA = {
    name: "Vtrender™ Gamma Exposure",
    title: "Gamma Exposure Analysis.",
    open: false,
    items: [
        {
            name: "NIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/bar-chart/NIFTY_Gamma_Curves",
            component: <BarChart id="nlcsv" />,
            stateData: NIFTY_GAMMA_CURVES_LINE_CHART_DATA,
            roles: ALLOWED_ROLES_ELITE, // Updated: Elite tier only
        },
        {
            name: "BANKNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/bar-chart/BANKNIFTY_Gamma_Curves",
            component: <BarChart id="bnlcsv" />,
            stateData: BANKNIFTY_GAMMA_CURVES_LINE_CHART_DATA,
            roles: ALLOWED_ROLES_ELITE, // Updated: Elite tier only
        },
        {
            name: "FINNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/bar-chart/FINNIFTY_Gamma_Curves",
            component: <BarChart id="fnlcsv" />,
            stateData: FINNIFTY_GAMMA_CURVES_LINE_CHART_DATA,
            roles: ALLOWED_ROLES_ELITE, // Updated: Elite tier only
        },
        {
            name: "MIDCPNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/bar-chart/MIDCPNIFTY_Gamma_Curves",
            component: <BarChart id="mnlcsv" />,
            stateData: MIDCPNIFTY_GAMMA_CURVES_LINE_CHART_DATA,
            roles: ALLOWED_ROLES_ELITE, // Updated: Elite tier only
        },
        {
            name: "SENSEX",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/bar-chart/SENSEX_Gamma_Curves",
            component: <BarChart id="snxlcsv" />,
            stateData: SENSEX_GAMMA_CURVES_LINE_CHART_DATA,
            roles: ALLOWED_ROLES_ELITE, // Updated: Elite tier only
        },
    ],
};

const NIFTY_OI_BAR_CHARTS_COMP = {
    name: "NF Options Strikewise oiViz Charts",
    // route: "/bar-chart?symbol=NIFTY&plot=net_gcash",
    route: "/bar-chart/NIFTY_Strike_OI",
    component: <BarChart id="nbarsv" />,
    stateData: NIFTY_OI_BAR_CHART_DATA,
    roles: ALLOWED_ROLES_PREMIUM,
};

const BANKNIFTY_OI_BAR_CHARTS_COMP = {
    name: "BN Options Strikewise oiViz Charts",
    // route: "/bar-chart?symbol=BANKNIFTY&plot=net_gcash",
    route: "/bar-chart/BANKNIFTY_Strike_OI",
    component: <BarChart id="bnbarsv" />,
    stateData: BANKNIFTY_OI_BAR_CHART_DATA,
    roles: ALLOWED_ROLES_PREMIUM,
};

const FINNIFTY_OI_BAR_CHARTS_COMP = {
    name: "FN Options Strikewise oiViz Charts",
    // route: "/bar-chart?symbol=BANKNIFTY&plot=net_gcash",
    route: "/bar-chart/FINNIFTY_Strike_OI",
    component: <BarChart id="fnbarsv" />,
    stateData: FINNIFTY_OI_BAR_CHART_DATA,
    roles: ALLOWED_ROLES_PREMIUM,
};

export const OI_BAR_CHARTS_DATA = {
    name: "Options Strikewise oiViz Charts",
    open: false,
    items: [
        {
            name: "NIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/bar-chart/NIFTY_Strike_OI",
            component: <BarChart id="nbarsv" />,
            stateData: NIFTY_OI_BAR_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "BANKNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/bar-chart/BANKNIFTY_Strike_OI",
            component: <BarChart id="bnbarsv" />,
            stateData: BANKNIFTY_OI_BAR_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "FINNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/bar-chart/FINNIFTY_Strike_OI",
            component: <BarChart id="fnbarsv" />,
            stateData: FINNIFTY_OI_BAR_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "MIDCPNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/bar-chart/MIDCPNIFTY_Strike_OI",
            component: <BarChart id="mnbarsv" />,
            stateData: MIDCPNIFTY_OI_BAR_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
    ],
};

const NIFTY_IV_CHARTS_COMP = {
    name: "NF IV Curve Charts",
    // route: "/bar-chart?symbol=NIFTY&plot=net_gcash",
    route: "/bar-chart/NIFTY_Strike_IV",
    component: <BarChart id="nbariv" />,
    stateData: NIFTY_IV_CHART_DATA,
    roles: ALLOWED_ROLES_PREMIUM,
};

const BANKNIFTY_IV_CHARTS_COMP = {
    name: "BN IV Curve Charts",
    // route: "/bar-chart?symbol=BANKNIFTY&plot=net_gcash",
    route: "/bar-chart/BANKNIFTY_Strike_IV",
    component: <BarChart id="bnbariv" />,
    stateData: BANKNIFTY_IV_CHART_DATA,
    roles: ALLOWED_ROLES_PREMIUM,
};

export const IV_CHARTS_DATA = {
    name: "IV Smile",
    title: "Track volatility shifts around news events.",
    open: false,
    items: [
        {
            name: "NIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/bar-chart/NIFTY_Strike_IV",
            component: <BarChart id="nbariv" />,
            stateData: NIFTY_IV_CHART_DATA,
            roles: ALLOWED_ROLES_ALL, // Updated: Free tier access
        },
        {
            name: "BANKNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/bar-chart/BANKNIFTY_Strike_IV",
            component: <BarChart id="bnbariv" />,
            stateData: BANKNIFTY_IV_CHART_DATA,
            roles: ALLOWED_ROLES_ALL, // Updated: Free tier access
        },
        {
            name: "SENSEX",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/bar-chart/SENSEX_Strike_IV",
            component: <BarChart id="snxbariv" />,
            stateData: SENSEX_IV_CHART_DATA,
            roles: ALLOWED_ROLES_ALL, // Updated: Free tier access
        },
    ],
};

export const OI_BAR_DATA = {
    name: "OI Viz",
    title: "Gain insights from open interest changes and volume moves.",
    open: false,
    items: [
        {
            name: "NIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/bar-chart/NIFTY_Strike_OI",
            component: <BarChart id="nbarsv" />,
            stateData: NIFTY_OI_BAR_CHART_DATA,
            roles: ALLOWED_ROLES_ALL, // Updated: Free tier access
        },
        {
            name: "BANKNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/bar-chart/BANKNIFTY_Strike_OI",
            component: <BarChart id="bnbarsv" />,
            stateData: BANKNIFTY_OI_BAR_CHART_DATA,
            roles: ALLOWED_ROLES_ALL, // Updated: Free tier access
        },
        {
            name: "FINNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/bar-chart/FINNIFTY_Strike_OI",
            component: <BarChart id="fnbarsv" />,
            stateData: FINNIFTY_OI_BAR_CHART_DATA,
            roles: ALLOWED_ROLES_ALL, // Updated: Free tier access
        },
        {
            name: "MIDCPNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/bar-chart/MIDCPNIFTY_Strike_OI",
            component: <BarChart id="mnbarsv" />,
            stateData: MIDCPNIFTY_OI_BAR_CHART_DATA,
            roles: ALLOWED_ROLES_ALL, // Updated: Free tier access
        },
        {
            name: "SENSEX",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/bar-chart/SENSEX_Strike_OI",
            component: <BarChart id="snxbarsv" />,
            stateData: SENSEX_OI_BAR_CHART_DATA,
            roles: ALLOWED_ROLES_ALL, // Updated: Free tier access
        },
    ],
};

const NIFTY_SNAKES_CHARTS_COMP = {
    name: "NF Options Snake Charts",
    // route: "/bar-chart?symbol=NIFTY&plot=net_gcash",
    route: "/line-chart/NIFTY_Snakes",
    component: <LineChart id="nfsnake" />,
    stateData: NIFTY_SNAKE_CHART_DATA,
    roles: ALLOWED_ROLES_PREMIUM,
};

const BANKNIFTY_SNAKES_CHARTS_COMP = {
    name: "BN Options Snake Charts",
    // route: "/bar-chart?symbol=NIFTY&plot=net_gcash",
    route: "/line-chart/BANKNIFTY_Snakes",
    component: <LineChart id="bnsnake" />,
    stateData: BANKNIFTY_SNAKE_CHART_DATA,
    roles: ALLOWED_ROLES_PREMIUM,
};

const FINNIFTY_SNAKES_CHARTS_COMP = {
    name: "FN Options Snake Charts",
    // route: "/bar-chart?symbol=NIFTY&plot=net_gcash",
    route: "/line-chart/FINNIFTY_Snakes",
    component: <LineChart id="fnfsnake" />,
    stateData: FINNIFTY_SNAKE_CHART_DATA,
    roles: ALLOWED_ROLES_PREMIUM,
};

export const SNAKES_CHARTS_DATA = {
    name: "Straddles",
    title: "Analysis of options pairs and more.",
    open: false,
    items: [
        {
            name: "NIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/line-chart/NIFTY_Snakes",
            component: <LineChart id="nfsnake" />,
            stateData: NIFTY_SNAKE_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "BANKNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/line-chart/BANKNIFTY_Snakes",
            component: <LineChart id="bnsnake" />,
            stateData: BANKNIFTY_SNAKE_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "FINNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/line-chart/FINNIFTY_Snakes",
            component: <LineChart id="fnfsnake" />,
            stateData: FINNIFTY_SNAKE_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "MIDCPNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/line-chart/MIDCPNIFTY_Snakes",
            component: <LineChart id="mcpnsnake" />,
            stateData: MIDCPNIFTY_SNAKE_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "SENSEX",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/line-chart/SENSEX_Snakes",
            component: <LineChart id="snxsnake" />,
            stateData: SENSEX_SNAKE_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
    ],
};

export const SNAKES_CHARTS_DATA_NEW = {
    name: "Straddles",
    title: "Analysis of options pairs and more.",
    open: false,
    items: [
        {
            name: "NIFTY",
            // route: "/line-chart?type=SINGLE&symbol=NIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/candle-line-chart/NIFTY_Snakes",
            component: <LineChartNew id="nfsnake" />,
            stateData: NIFTY_SNAKE_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "BANKNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/candle-line-chart/BANKNIFTY_Snakes",
            component: <LineChartNew id="bnsnake" />,
            stateData: BANKNIFTY_SNAKE_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "FINNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/candle-line-chart/FINNIFTY_Snakes",
            component: <LineChartNew id="fnfsnake" />,
            stateData: FINNIFTY_SNAKE_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "MIDCPNIFTY",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/candle-line-chart/MIDCPNIFTY_Snakes",
            component: <LineChartNew id="mcpnsnake" />,
            stateData: MIDCPNIFTY_SNAKE_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
        {
            name: "SENSEX",
            // route: "/line-chart?type=SINGLE&symbol=BANKNIFTY&startDate=&nDays=1&plot=all_doix",
            route: "/candle-line-chart/SENSEX_Snakes",
            component: <LineChartNew id="mcpnsnake" />,
            stateData: SENSEX_SNAKE_CHART_DATA,
            roles: ALLOWED_ROLES_PREMIUM,
        },
    ],
};

export const ADMIN_PAGES_PRO2_DATA = {
    name: "System Admin",
    open: false,
    items: [
        {
            name: "User Admin",
            route: "/user-admin",
            roles: ALLOWED_ROLES_PRO2,
        },
        {
            name: "Marketing Messages",
            route: "/marketing-messages",
            roles: ALLOWED_ROLES_PRO2,
        },
    ],
};

export const ADMIN_PAGES_DATA = {
    name: "System Admin",
    open: false,
    items: [
        {
            name: "Feed Admin",
            route: "/feed-admin",
            roles: ALLOWED_ROLES_ADMIN,
        },
        {
            name: "User Admin",
            route: "/user-admin",
            roles: ALLOWED_ROLES_PRO2,
        },
        {
            name: "Marketing Messages",
            route: "/marketing-messages",
            roles: ALLOWED_ROLES_PRO2,
        },
    ],
};

const OPTIONS_TABLE_COMP = {
    name: "Options Table",
    title: "Enhanced Options Data analysis.",
    route: "/options-table",
    component: <OPTIONS_TABLE />,
    roles: ALLOWED_ROLES_ALL,
};

const PREMIUM_OPTIONS_TABLE_COMP = {
    name: "Options Table",
    title: "Enhanced Options Data analysis.",
    route: "/options-table",
    component: <OPTIONS_TABLE />,
    roles: ALLOWED_ROLES_ALL,
};

const GREEKS_TABLE_COMP = {
    name: "Option Greeks",
    title: "Track your positions and profits in real time and calculate future pnl projection with greeks.",
    route: "/greek-chart",
    component: <GREEKS_TABLE />,
    roles: ALLOWED_ROLES_ALL,
};

const PAYOFFCHART_COMP = {
    name: "Payoff Chart",
    route: "/payoff-chart",
    component: <PAYOFF_CHART />,
    roles: ALLOWED_ROLES_ALL, // Updated: Free tier access
};

const INDEX_TABLE_COMP = {
    name: "Indices",
    title: "Know which component is moving the index from the inside.",
    route: "/index-table",
    component: <INDEX_TABLE />,
    roles: ALLOWED_ROLES_ALL,
};

const FII_DATA_COMP = {
    name: "FII Data",
    title: "Foreign Holdings.",
    route: "/fii-data",
    roles: ALLOWED_ROLES_ALL,
};

const POSITION_TABLE_COMP = {
    name: "Participantwise Positions",
    title: "All participant Holdings.",
    route: "/position-table",
    roles: ALLOWED_ROLES_ALL,
};

const FEED_ADMIN_COMP = {
    name: "Feed Admin",
    route: "/feed-admin",
    roles: ALLOWED_ROLES_ADMIN,
};

const USER_ADMIN_COMP = {
    name: "User Admin",
    route: "/user-admin",
    roles: ALLOWED_ROLES_PRO2, // PRO2-only feature
};

export const BOOKMARK_COMP = {
    name: "MP Bookmarks",
    title: "Market Profile features specific Bookmarks.",
    route: "/bookmarks",
    component: <Bookmark />,
    roles: ALLOWED_ROLES_PREMIUM,
};

export const GLOBAL_BOOKMARK_COMP = {
    name: "Global Bookmarks",
    title: "Save and revisit your favorite chart layouts instantly.",
    route: "/global-bookmarks",
    component: <GlobalBookmarks />,
    roles: ALLOWED_ROLES_ELITE, // Updated: Elite tier only (pro1 role)
    resources: RESOURCE_LIST.ORDERFLOW,
};

const PROFILE_DETAILS_COMP = {
    name: "Profile",
    route: "/profile",
    roles: ALLOWED_ROLES_ALL,
};

const SETTINGS_COMP = {
    name: "User Settings",
    route: "/settings",
    roles: ALLOWED_ROLES_ALL,
};

const NEW_USER_MANUAL_COMP = {
    name: "User Manual",
    route: "/user-manual",
    roles: ALLOWED_ROLES_ALL,
};

const FAQ_COMP = {
    name: "FAQ",
    route: "/faq",
    roles: ALLOWED_ROLES_ALL,
};

const GLOSSARY_COMP = {
    name: "Glossary",
    route: "/glossary",
    roles: ALLOWED_ROLES_ALL,
};

const INTRO_COMP = {
    name: "Intro Videos",
    route: "/intros",
    roles: ALLOWED_ROLES_ALL,
};

const HELP_COMP = {
    name: "Help",
    route: "/help",
    roles: ALLOWED_ROLES_ALL,
};

const SUBSCRIPTION_COMPONENT = {
    name: "Subscription Plans",
    route: "/subscription",
    roles: ALLOWED_ROLES_ALL,
};

// const SUBSCRIPTION_COMPONENT_NEW={
//   name:"Subscription Plans New",
//   route:"/subscription-new",
//   roles:ALLOWED_ROLES_ELITE
// }

// ============================================================
// OLD - Deprecated function (DEPRECATED)
// Replaced by: getDrawerListNew(permissions)
// See: src/common/utility/permissionService.js
// NOTE: Still used by drawerNestedMenu.js - should be migrated
// ============================================================
export const getDrawerList = (auth) => {
    console.log("auth=", auth);
    // ============================================================
    // OLD - Hardcoded permission checks (DEPRECATED)
    // Replaced by: Centralized permission service
    // See: src/common/utility/permissionService.js
    // ============================================================
    // const isAdmin = (auth.role.find(el => el == USER_ROLE_FIELDS.ADMIN)) ? true : false;
    // const isPRO_1 = (auth.role.find(el => el == USER_ROLE_FIELDS.PRO)) ? true : false;
    // const isPRO_2 = (auth.role.find(el => el == USER_ROLE_FIELDS.PRO2)) ? true : false;
    // const isFastData = (auth.role.find(el => el == USER_ROLE_FIELDS.FAST_DATA)) ? true : false;
    // const isBasic = true;
    // const isEliteUser = (auth.role.find(el => el == USER_ROLE_FIELDS.PRO) && auth.resources.find(el => el == USER_RESOURCES_LIST.TBT_FEED))
    // const isEcourseBought=auth.resources.find(el => el == USER_RESOURCES_LIST.E_COURSE)

    // NEW - Use centralized permission service
    const permissions = createPermissionService(auth);
    let drawerList = [];
    const isAdmin = permissions.isAdmin();
    // Use centralized permission service - force migration, no backward compatibility
    const isPRO_1 = permissions.isEliteUser(); // PRO1 or PRO2
    // PRO2-only feature
    const isPRO_2 = permissions.isPro2User();
    const isFastData = permissions.isPremiumUser(); // PREMIUM, PRO1, or PRO2
    const isBasic = true;
    const isEliteUser = permissions.isEliteUser();
    const isEcourseBought = permissions.hasResource(
        USER_RESOURCES_LIST.E_COURSE,
    );

    if (isAdmin) {
        drawerList.push(SUBSCRIPTION_COMPONENT);
        // drawerList.push(SUBSCRIPTION_COMPONENT_NEW);
        // if(!isEcourseBought)
        //   drawerList.push(ECOURSE_COMPONENT)
        drawerList.push(BROKER_LOGIN_COMPONENT);
        drawerList.push(MP_CHART_COMP);
        drawerList.push(OF_CHART_COMP);
        drawerList.push(OF_REPLAY_COMP);
        drawerList.push(IV_RANGE_CHART_DATA);
        // drawerList.push(CANLDE_CHART_COMP);
        if (isEliteUser) drawerList.push(LINE_CHART_COMP_NEW);
        else drawerList.push(LINE_CHART_COMP);

        drawerList.push(OPTIONS_TABLE_COMP);
        drawerList.push(GREEKS_TABLE_COMP);
        drawerList.push(PAYOFFCHART_COMP);
        drawerList.push(INDEX_TABLE_COMP);
        // if(isEliteUser){
        drawerList.push(SPOT_OIX_CHART_DATA);
        drawerList.push(SPOT_OIX_CHART_DATA_NEW);
        drawerList.push(ALLOPT_DOIX_CHART_DATA);
        drawerList.push(ALLOPT_DOIX_CHART_DATA_NEW);
        drawerList.push(ALLOPT_DOI_CHART_DATA);
        drawerList.push(ALLOPT_DOI_CHART_DATA_NEW);
        drawerList.push(ALLOPT_VOLX_CHART_DATA);
        drawerList.push(ALLOPT_VOLX_CHART_DATA_NEW);
        drawerList.push(ALLOPT_DVOLX_CHART_DATA);
        drawerList.push(ALLOPT_DVOLX_CHART_DATA_NEW);
        drawerList.push(ALLOPT_VOL_CHART_DATA);
        drawerList.push(ALLOPT_VOL_CHART_DATA_NEW);
        drawerList.push(FUTURES_OIX_CHART_DATA);
        drawerList.push(FUTURES_OIX_CHART_DATA_NEW);
        // }else{

        // }

        drawerList.push(GCASH_BAR_CHARTS_DATA);
        drawerList.push(WCASH_BAR_CHARTS_DATA);
        drawerList.push(GAMMA_DENSITY_LINE_DATA);
        drawerList.push(OI_BAR_CHARTS_DATA);
        drawerList.push(IV_CHARTS_DATA);
        if (isEliteUser) drawerList.push(SNAKES_CHARTS_DATA_NEW);
        else drawerList.push(SNAKES_CHARTS_DATA);

        drawerList.push(HV_CHART_DATA);
        drawerList.push(FII_DATA_COMP);
        drawerList.push(POSITION_TABLE_COMP);
        // drawerList.push(FEED_ADMIN_COMP);
        // drawerList.push(USER_ADMIN_COMP);
        drawerList.push(BOOKMARK_COMP);
        if (isEliteUser) drawerList.push(GLOBAL_BOOKMARK_COMP);

        drawerList.push(ADMIN_PAGES_DATA);
        drawerList.push(PROFILE_DETAILS_COMP);
        drawerList.push(SETTINGS_COMP);
        drawerList.push(NEW_USER_MANUAL_COMP);
        drawerList.push(FAQ_COMP);
        drawerList.push(INTRO_COMP);
        // drawerList.push(HELP_COMP);
    } else if (isPRO_2) {
        drawerList.push(SUBSCRIPTION_COMPONENT);
        // if(!isEcourseBought)
        //   drawerList.push(ECOURSE_COMPONENT)
        // drawerList.push(SUBSCRIPTION_COMPONENT_NEW);
        drawerList.push(BROKER_LOGIN_COMPONENT);
        drawerList.push(MP_CHART_COMP);
        drawerList.push(OF_CHART_COMP);
        drawerList.push(OF_REPLAY_COMP);
        // drawerList.push(CANLDE_CHART_COMP);
        if (isEliteUser) drawerList.push(LINE_CHART_COMP_NEW);
        else drawerList.push(LINE_CHART_COMP);

        drawerList.push(OPTIONS_TABLE_COMP);
        drawerList.push(GREEKS_TABLE_COMP);
        drawerList.push(PAYOFFCHART_COMP);
        drawerList.push(INDEX_TABLE_COMP);
        if (isEliteUser) {
            drawerList.push(SPOT_OIX_CHART_DATA_NEW);
            drawerList.push(ALLOPT_DOIX_CHART_DATA_NEW);
            drawerList.push(ALLOPT_DOI_CHART_DATA_NEW);
            drawerList.push(ALLOPT_VOLX_CHART_DATA_NEW);
            drawerList.push(ALLOPT_DVOLX_CHART_DATA_NEW);
            drawerList.push(ALLOPT_VOL_CHART_DATA_NEW);
            drawerList.push(FUTURES_OIX_CHART_DATA_NEW);
        } else {
            drawerList.push(SPOT_OIX_CHART_DATA);
            drawerList.push(ALLOPT_DOIX_CHART_DATA);
            drawerList.push(ALLOPT_DOI_CHART_DATA);
            drawerList.push(ALLOPT_VOLX_CHART_DATA);
            drawerList.push(ALLOPT_DVOLX_CHART_DATA);
            drawerList.push(ALLOPT_VOL_CHART_DATA);
            drawerList.push(FUTURES_OIX_CHART_DATA);
        }
        // drawerList.push(ALLOPT_DVOLX_CHART_DATA);
        // drawerList.push(ALLOPT_VOL_CHART_DATA);
        drawerList.push(GCASH_BAR_CHARTS_DATA);
        drawerList.push(WCASH_BAR_CHARTS_DATA);
        drawerList.push(GAMMA_DENSITY_LINE_DATA);
        drawerList.push(OI_BAR_CHARTS_DATA);
        drawerList.push(IV_CHARTS_DATA);
        drawerList.push(HV_CHART_DATA);
        if (isEliteUser) drawerList.push(SNAKES_CHARTS_DATA_NEW);
        else drawerList.push(SNAKES_CHARTS_DATA);

        drawerList.push(FII_DATA_COMP);
        // drawerList.push(POSITION_TABLE_COMP);
        // drawerList.push(USER_ADMIN_COMP);
        drawerList.push(BOOKMARK_COMP);
        if (isEliteUser) drawerList.push(GLOBAL_BOOKMARK_COMP);
        drawerList.push(ADMIN_PAGES_PRO2_DATA);
        drawerList.push(PROFILE_DETAILS_COMP);
        drawerList.push(SETTINGS_COMP);
        drawerList.push(NEW_USER_MANUAL_COMP);
        drawerList.push(FAQ_COMP);
        drawerList.push(INTRO_COMP);
        // drawerList.push(HELP_COMP);
    } else {
        drawerList.push(SUBSCRIPTION_COMPONENT);
        // if(!isEcourseBought)
        //   drawerList.push(ECOURSE_COMPONENT)
        // drawerList.push(BROKER_LOGIN_COMPONENT);
        drawerList.push(MP_CHART_COMP);
        drawerList.push(OF_CHART_COMP);
        drawerList.push(OF_REPLAY_COMP);
        if (isEliteUser) drawerList.push(LINE_CHART_COMP_NEW);
        else drawerList.push(LINE_CHART_COMP);

        // drawerList.push(CANLDE_CHART_COMP);
        drawerList.push(OPTIONS_TABLE_COMP);
        drawerList.push(GREEKS_TABLE_COMP);
        drawerList.push(PAYOFFCHART_COMP);
        drawerList.push(INDEX_TABLE_COMP);

        if (isEliteUser) {
            drawerList.push(SPOT_OIX_CHART_DATA_NEW);
            drawerList.push(ALLOPT_DOIX_CHART_DATA_NEW);
            drawerList.push(ALLOPT_DOI_CHART_DATA_NEW);
            drawerList.push(ALLOPT_VOLX_CHART_DATA_NEW);
            // drawerList.push(ALLOPT_DVOLX_CHART_DATA_NEW);
            drawerList.push(ALLOPT_VOL_CHART_DATA_NEW);
        } else {
            drawerList.push(SPOT_OIX_CHART_DATA);
            drawerList.push(ALLOPT_DOIX_CHART_DATA);
            drawerList.push(ALLOPT_DOI_CHART_DATA);
            drawerList.push(ALLOPT_VOLX_CHART_DATA);
            // drawerList.push(ALLOPT_DVOLX_CHART_DATA);
            drawerList.push(ALLOPT_VOL_CHART_DATA);
        }

        drawerList.push(GCASH_BAR_CHARTS_DATA);
        drawerList.push(WCASH_BAR_CHARTS_DATA);
        drawerList.push(GAMMA_DENSITY_LINE_DATA);
        drawerList.push(OI_BAR_CHARTS_DATA);
        drawerList.push(IV_CHARTS_DATA);
        if (isEliteUser) drawerList.push(SNAKES_CHARTS_DATA_NEW);
        else drawerList.push(SNAKES_CHARTS_DATA);

        drawerList.push(HV_CHART_DATA);
        drawerList.push(FII_DATA_COMP);
        drawerList.push(BOOKMARK_COMP);
        // if (isEliteUser)
        drawerList.push(GLOBAL_BOOKMARK_COMP);
        drawerList.push(PROFILE_DETAILS_COMP);
        drawerList.push(SETTINGS_COMP);
        drawerList.push(NEW_USER_MANUAL_COMP);
        drawerList.push(FAQ_COMP);
        drawerList.push(INTRO_COMP);
        // drawerList.push(HELP_COMP);
    }
    console.log("configdata drawerlist=", drawerList);
    return drawerList;
};
export const getDrawerListNew = (permissions) => {
    // ============================================================
    // OLD - Hardcoded permission checks (DEPRECATED)
    // Replaced by: Centralized permission service methods
    // See: src/common/utility/permissionService.js
    // ============================================================
    // const isAdmin = (auth.role.find(el => el == USER_ROLE_FIELDS.ADMIN)) ? true : false;
    // const isPRO_1 = (auth.role.find(el => el == USER_ROLE_FIELDS.PRO)) ? true : false;
    // const isPRO_2 = (auth.role.find(el => el == USER_ROLE_FIELDS.PRO2)) ? true : false;
    // const isFastData = (auth.role.find(el => el == USER_ROLE_FIELDS.FAST_DATA)) ? true : false;
    // const isBasic = true;
    // const isEliteUser = (auth.role.find(el => el == USER_ROLE_FIELDS.PRO) && auth.resources.find(el => el == USER_RESOURCES_LIST.TBT_FEED))

    // NEW - Use centralized permission service
    const isAdmin = permissions.isAdmin();
    const isEliteUser = permissions.isEliteUser();
    const isPremiumUser = permissions.isPremiumUser();
    const isFreeUser = permissions.isFreeUser();

    // Use centralized permission service - force migration, no backward compatibility
    const isPRO_1 = permissions.isEliteUser(); // PRO1 or PRO2
    // PRO2-only feature
    const isPRO_2 = permissions.isPro2User();
    const isFastData = permissions.isPremiumUser(); // PREMIUM, PRO1, or PRO2

    const headerItems = [];
    const freeAccess = [];
    const premiumAccess = [];
    // ============================================================
    // OLD - Expert tier removed in new 3-tier system
    // Expert features merged into Premium tier
    // Old 4-tier: Free → Premium → Expert → Elite
    // New 3-tier: Free → Premium (includes old Expert) → Elite
    // ============================================================
    // const expertAccess = [];
    const eliteAccess = [];
    const footerItems = [];
    const adminItems = [];

    headerItems.push(SUBSCRIPTION_COMPONENT);

    // Broker login requires pro1 role (Elite tier)
    if (isPRO_2) headerItems.push(BROKER_LOGIN_COMPONENT);

    // ==================== FREE ACCESS (Basic role) ====================
    // Basic role access: MP Charts, Total OI, Total Volume, IV Curve, OI Viz,
    // Options Table, Indices Table, Greeks Table, Payoff Charts,
    // Historical Volatility stats chart, Participantwise positions table, FII data analysis

    // All free users get these features (regardless of premium/elite status)
    if (!isPremiumUser) freeAccess.push(MP_CHART_COMP); // MP Charts
    freeAccess.push(OPTIONS_TABLE_COMP); // Options Table
    freeAccess.push(PAYOFFCHART_COMP); // Payoff Charts
    freeAccess.push(GREEKS_TABLE_COMP); // Greeks Table
    freeAccess.push(IV_CHARTS_DATA); // IV Curve
    freeAccess.push(WCASH_BAR_CHARTS_DATA); // WCash
    freeAccess.push(OI_BAR_DATA); // OI Viz (OI Bar Charts)
    freeAccess.push(ALLOPT_DOI_CHART_DATA); // Total OI
    freeAccess.push(ALLOPT_VOL_CHART_DATA); // Total Volume
    freeAccess.push(HV_CHART_DATA); // Historical Volatility stats chart
    freeAccess.push(POSITION_TABLE_COMP); // Participantwise positions table
    freeAccess.push(FII_DATA_COMP); // FII data analysis
    freeAccess.push(INDEX_TABLE_COMP); // Indices Table

    // ==================== PREMIUM ACCESS ====================
    // Premium role access: All basic role features (inherited) +
    // NTM OI, NTM Volx, Spectrum, WCash, MP Bookmarks,
    // Custom & Anchored KRLs, Historical data comparing ability, Multi-window view

    // Premium tier features - available to Premium and Elite users
    premiumAccess.push(MP_ADV_CHART_COMP); // Advanced Market Profile (includes Custom & Anchored KRLs)
    // premiumAccess.push(LINE_CHART_COMP);               // Line Charts (includes Historical data comparing ability, Multi-window)
    premiumAccess.push(SPOT_OIX_CHART_DATA_NEW); // Spectrum
    premiumAccess.push(ALLOPT_VOLX_CHART_DATA_NEW); // NTM Volx
    premiumAccess.push(ALLOPT_DOIX_CHART_DATA_NEW); // NTM OI
    // premiumAccess.push(WCASH_BAR_CHARTS_DATA);         // WCash

    premiumAccess.push(SNAKES_CHARTS_DATA_NEW); // OI Snakes (Premium feature)
    // premiumAccess.push(GCASH_BAR_CHARTS_DATA);         // Gamma Cash (Elite feature)
    premiumAccess.push(BOOKMARK_COMP); // MP Bookmarks

    // Admin-only features in Premium section
    if (isAdmin) premiumAccess.push(FUTURES_OIX_CHART_DATA_NEW);

    // ==================== ELITE ACCESS (Pro1 role) ====================
    // Pro1 role access (Elite vertical): All Premium and basic role features (inherited) +
    // Orderflow charts, Replay of Orderflow charts, Smart Candlestick charts,
    // Gamma Density and Exposure, Global bookmarks

    // Elite tier features - only for Elite users (pro1 role)
    // if(isEliteUser)
    // {
    eliteAccess.push(OF_CHART_COMP); // Orderflow charts
    eliteAccess.push(OF_REPLAY_COMP); // Orderflow Replay - post-market analysis
    eliteAccess.push(IV_RANGE_CHART_DATA);
    eliteAccess.push(LINE_CHART_COMP_NEW); // Smart Candlestick™ charts
    eliteAccess.push(GAMMA_DENSITY_LINE_DATA); // Gamma Density and Exposure
    eliteAccess.push(GAMMA_CURVES_LINE_DATA); // Gamma Exposure Curves\
    eliteAccess.push(GLOBAL_BOOKMARK_COMP); // Global bookmarks
    // Note: Replay of Orderflow is part of OF_CHART_COMP functionality
    // }
    // else
    // {
    //   // Non-elite users see locked versions of Elite features
    //   eliteAccess.push(OF_CHART_COMP);                 // Orderflow charts (locked)
    //   eliteAccess.push(LINE_CHART_COMP_NEW);          // Smart Candlestick™ charts (locked)
    //   eliteAccess.push(GAMMA_DENSITY_LINE_DATA);       // Gamma Density (locked)
    //   eliteAccess.push(GAMMA_CURVES_LINE_DATA);        // Gamma Curves (locked)
    //   eliteAccess.push(GLOBAL_BOOKMARK_COMP);          // Global bookmarks (locked)
    // }

    // Footer items - admin only, pro2 has user-admin access
    if (isAdmin) {
        footerItems.push(ADMIN_PAGES_DATA);
    } else if (isPRO_2) {
        footerItems.push(ADMIN_PAGES_PRO2_DATA);
    }

    footerItems.push(
        PROFILE_DETAILS_COMP,
        SETTINGS_COMP,
        NEW_USER_MANUAL_COMP,
        GLOSSARY_COMP,
        FAQ_COMP,
        INTRO_COMP,
    );

    // ============================================================
    // NEW 3-TIER SYSTEM: Free → Premium → Elite → PRO2
    // Roles: basic, premium, pro1 (Elite), pro2, admin
    // Hierarchy: BASIC < PREMIUM < PRO1 < PRO2 < ADMIN
    // ============================================================
    return [
        { title: null, data: headerItems, id: "header" },
        {
            title: "ELITE",
            data: eliteAccess,
            color: "#EC6C10",
            id: TIERS.ELITE,
            subtittle: "Crème de la crème",
        },
        {
            title: "PROFESSIONAL",
            data: premiumAccess,
            color: "#23B1BA",
            id: TIERS.PREMIUM,
            subtittle: "Proprietary charts - Live NSE feed",
        },
        {
            title: "FREE ACCESS",
            data: freeAccess,
            color: "#FFFFFF",
            id: TIERS.FREE,
            subtittle: "Zero cost - High value",
        },
        { title: null, data: footerItems, id: "footer" },
    ];
};

export const TIME_FRAME = [
    {
        key: "D",
        value: "daily",
        displayText: "Daily",
    },
    {
        key: "W",
        value: "weekly",
        displayText: "Calendar Week",
    },
    {
        key: "W_S",
        value: "weekly_s",
        displayText:
            "Weekly Series (Next day of Expiry to next Expiry day. Eg. Fri to Thu for NIFTY; Thu to Wed for BANKNIFTY and so on..)",
    },
    {
        key: "M",
        value: "monthly",
        displayText: "Calendar Month",
    },
    {
        key: "M_S",
        value: "monthly_s",
        displayText: "Monthly Series (Starting Friday post Expiry)",
    },
    {
        key: "Y",
        value: "yearly_d",
        displayText: "Calendar Year",
    },
];

export const getChartOptionsData = (auth) => {
    console.log("auth=", auth);
    // ============================================================
    // OLD - Hardcoded permission checks (DEPRECATED)
    // Replaced by: Centralized permission service
    // See: src/common/utility/permissionService.js
    // ============================================================
    // const isAdmin=(auth.role.find(el=>el==USER_ROLE_FIELDS.ADMIN))?true:false;
    // const isPRO_1=(auth.role.find(el=>el==USER_ROLE_FIELDS.PRO))?true:false;
    // const isPRO_2=(auth.role.find(el=>el==USER_ROLE_FIELDS.PRO2))?true:false;
    // const isFastData=(auth.role.find(el=>el==USER_ROLE_FIELDS.FAST_DATA))?true:false;
    // const isBasic=(auth.role.find(el=>el==USER_ROLE_FIELDS.ADMIN))?true:false;
    // const isEliteUser = (auth.role.find(el => el == USER_ROLE_FIELDS.PRO) && auth.resources.find(el => el == USER_RESOURCES_LIST.TBT_FEED))

    // NEW - Use centralized permission service
    const permissions = createPermissionService(auth);
    let chartList = [];
    const isAdmin = permissions.isAdmin();
    // Use centralized permission service - force migration, no backward compatibility
    const isPRO_1 = permissions.isEliteUser(); // PRO1 or PRO2
    // PRO2-only feature
    const isPRO_2 = permissions.isPro2User();
    const isFastData = permissions.isPremiumUser(); // PREMIUM, PRO1, or PRO2
    const isBasic = permissions.isFreeUser();
    const isEliteUser = permissions.isEliteUser();

    chartList.push(NIFTY_ALLOPT_VOLX_CHART_DATA);
    chartList.push(BANKNIFTY_ALLOPT_VOLX_CHART_DATA);
    chartList.push(SENSEX_ALLOPT_VOLX_CHART_DATA);
    chartList.push(NIFTY_SPOT_OIX_CHART_DATA);
    chartList.push(BANKNIFTY_SPOT_OIX_CHART_DATA);
    chartList.push(SENSEX_SPOT_OIX_CHART_DATA);
    chartList.push(NIFTY_IV_RANGE_CHART_DATA);
    chartList.push(SENSEX_IV_RANGE_CHART_DATA);
    chartList.push(NIFTY_GAMMA_DENSITY_LINE_CHART_DATA);
    chartList.push(BANKNIFTY_GAMMA_DENSITY_LINE_CHART_DATA);
    chartList.push(SENSEX_GAMMA_DENSITY_LINE_CHART_DATA);
    chartList.push(NIFTY_GAMMA_CURVES_LINE_CHART_DATA);
    chartList.push(BANKNIFTY_GAMMA_CURVES_LINE_CHART_DATA);
    chartList.push(SENSEX_GAMMA_CURVES_LINE_CHART_DATA);
    chartList.push(NIFTY_GCASH_BAR_CHART_DATA);
    chartList.push(BANKNIFTY_GCASH_BAR_CHART_DATA);
    chartList.push(SENSEX_GCASH_BAR_CHART_DATA);
    chartList.push(NIFTY_ALLOPT_DOIX_CHART_DATA);
    chartList.push(BANKNIFTY_ALLOPT_DOIX_CHART_DATA);
    chartList.push(SENSEX_ALLOPT_DOIX_CHART_DATA);

    if (isAdmin) {
        chartList.push(NIFTY_FUTURES_OIX_CHART_DATA);
        chartList.push(BANKNIFTY_FUTURES_OIX_CHART_DATA);
    }

    chartList.push(NIFTY_OI_BAR_CHART_DATA);
    chartList.push(BANKNIFTY_OI_BAR_CHART_DATA);
    chartList.push(SENSEX_OI_BAR_CHART_DATA);
    chartList.push(NIFTY_WCASH_BAR_CHART_DATA);
    chartList.push(BANKNIFTY_WCASH_BAR_CHART_DATA);
    chartList.push(SENSEX_WCASH_BAR_CHART_DATA);
    chartList.push(NIFTY_IV_CHART_DATA);
    chartList.push(BANKNIFTY_IV_CHART_DATA);
    chartList.push(SENSEX_IV_CHART_DATA);

    chartList.push(NIFTY_ALLOPT_DOI_CHART_DATA);
    chartList.push(BANKNIFTY_ALLOPT_DOI_CHART_DATA);
    chartList.push(SENSEX_ALLOPT_DOI_CHART_DATA);
    chartList.push(NIFTY_ALLOPT_VOL_CHART_DATA);
    chartList.push(BANKNIFTY_ALLOPT_VOL_CHART_DATA);
    chartList.push(SENSEX_ALLOPT_VOL_CHART_DATA);

    if (isAdmin) {
        chartList.push(NIFTY_ALLOPT_DVOLX_CHART_DATA);
        chartList.push(BANKNIFTY_ALLOPT_DVOLX_CHART_DATA);
        chartList.push(FINNIFTY_ALLOPT_DVOLX_CHART_DATA);
        chartList.push(MIDCPNIFTY_ALLOPT_DVOLX_CHART_DATA);
    }

    chartList.push(NIFTY_SNAKE_CHART_DATA);
    chartList.push(BANKNIFTY_SNAKE_CHART_DATA);
    chartList.push(SENSEX_SNAKE_CHART_DATA);

    chartList.push(NIFTY_HV_CHART_DATA);
    chartList.push(BANKNIFTY_HV_CHART_DATA);

    chartList.push(FINNIFTY_ALLOPT_VOLX_CHART_DATA);
    chartList.push(MIDCPNIFTY_ALLOPT_VOLX_CHART_DATA);
    chartList.push(FINNIFTY_SPOT_OIX_CHART_DATA);
    chartList.push(MIDCPNIFTY_SPOT_OIX_CHART_DATA);
    chartList.push(FINNIFTY_ALLOPT_DOIX_CHART_DATA);
    chartList.push(MIDCPNIFTY_ALLOPT_DOIX_CHART_DATA);
    chartList.push(FINNIFTY_GCASH_BAR_CHART_DATA);
    chartList.push(MIDCPNIFTY_GCASH_BAR_CHART_DATA);
    chartList.push(FINNIFTY_OI_BAR_CHART_DATA);
    chartList.push(MIDCPNIFTY_OI_BAR_CHART_DATA);
    chartList.push(FINNIFTY_WCASH_BAR_CHART_DATA);
    chartList.push(MIDCPNIFTY_WCASH_BAR_CHART_DATA);
    if (isEliteUser) {
        chartList.push(FINNIFTY_GAMMA_DENSITY_LINE_CHART_DATA);
        chartList.push(MIDCPNIFTY_GAMMA_DENSITY_LINE_CHART_DATA);
        chartList.push(FINNIFTY_GAMMA_CURVES_LINE_CHART_DATA);
        chartList.push(MIDCPNIFTY_GAMMA_CURVES_LINE_CHART_DATA);
    }
    chartList.push(FINNIFTY_ALLOPT_DOI_CHART_DATA);
    chartList.push(MIDCPNIFTY_ALLOPT_DOI_CHART_DATA);
    chartList.push(FINNIFTY_ALLOPT_VOL_CHART_DATA);
    chartList.push(MIDCPNIFTY_ALLOPT_VOL_CHART_DATA);
    chartList.push(FINNIFTY_SNAKE_CHART_DATA);
    chartList.push(MIDCPNIFTY_SNAKE_CHART_DATA);

    // if(isAdmin){
    //   chartList.push(NIFTY_ALLOPT_VOLX_CHART_DATA);
    //   chartList.push(BANKNIFTY_ALLOPT_VOLX_CHART_DATA);
    //   chartList.push(FINNIFTY_ALLOPT_VOLX_CHART_DATA);
    //   chartList.push(MIDCPNIFTY_ALLOPT_VOLX_CHART_DATA);
    //   chartList.push(NIFTY_SPOT_OIX_CHART_DATA);
    //   chartList.push(BANKNIFTY_SPOT_OIX_CHART_DATA);
    //   chartList.push(FINNIFTY_SPOT_OIX_CHART_DATA);
    //   chartList.push(MIDCPNIFTY_SPOT_OIX_CHART_DATA);
    //   chartList.push(NIFTY_ALLOPT_DOIX_CHART_DATA);
    //   chartList.push(BANKNIFTY_ALLOPT_DOIX_CHART_DATA);
    //   chartList.push(FINNIFTY_ALLOPT_DOIX_CHART_DATA);
    //   chartList.push(MIDCPNIFTY_ALLOPT_DOIX_CHART_DATA);
    //   chartList.push(NIFTY_GCASH_BAR_CHART_DATA);
    //   chartList.push(BANKNIFTY_GCASH_BAR_CHART_DATA);
    //   chartList.push(FINNIFTY_GCASH_BAR_CHART_DATA);
    //   chartList.push(MIDCPNIFTY_GCASH_BAR_CHART_DATA);

    //   chartList.push(NIFTY_FUTURES_OIX_CHART_DATA);
    //   chartList.push(BANKNIFTY_FUTURES_OIX_CHART_DATA);

    //   chartList.push(NIFTY_OI_BAR_CHART_DATA);
    //   chartList.push(BANKNIFTY_OI_BAR_CHART_DATA);
    //   chartList.push(FINNIFTY_OI_BAR_CHART_DATA);
    //   chartList.push(MIDCPNIFTY_OI_BAR_CHART_DATA);
    //   chartList.push(NIFTY_IV_CHART_DATA);
    //   chartList.push(BANKNIFTY_IV_CHART_DATA);

    //   chartList.push(NIFTY_ALLOPT_DOI_CHART_DATA);
    //   chartList.push(BANKNIFTY_ALLOPT_DOI_CHART_DATA);
    //   chartList.push(FINNIFTY_ALLOPT_DOI_CHART_DATA);
    //   chartList.push(MIDCPNIFTY_ALLOPT_DOI_CHART_DATA);

    //   chartList.push(NIFTY_ALLOPT_DVOLX_CHART_DATA);
    //   chartList.push(BANKNIFTY_ALLOPT_DVOLX_CHART_DATA);
    //   chartList.push(FINNIFTY_ALLOPT_DVOLX_CHART_DATA);
    //   chartList.push(MIDCPNIFTY_ALLOPT_DVOLX_CHART_DATA);

    //   chartList.push(NIFTY_ALLOPT_VOL_CHART_DATA);
    //   chartList.push(BANKNIFTY_ALLOPT_VOL_CHART_DATA);
    //   chartList.push(FINNIFTY_ALLOPT_VOL_CHART_DATA);
    //   chartList.push(MIDCPNIFTY_ALLOPT_VOL_CHART_DATA);

    //   chartList.push(NIFTY_SNAKE_CHART_DATA);
    //   chartList.push(BANKNIFTY_SNAKE_CHART_DATA);
    //   chartList.push(FINNIFTY_SNAKE_CHART_DATA);
    //   chartList.push(MIDCPNIFTY_SNAKE_CHART_DATA);
    //   chartList.push(NIFTY_HV_CHART_DATA);
    //   chartList.push(BANKNIFTY_HV_CHART_DATA);
    // }else if(isPRO_2){
    //   chartList.push(NIFTY_ALLOPT_VOLX_CHART_DATA);
    //   chartList.push(BANKNIFTY_ALLOPT_VOLX_CHART_DATA);
    //   chartList.push(FINNIFTY_ALLOPT_VOLX_CHART_DATA);
    //   chartList.push(MIDCPNIFTY_ALLOPT_VOLX_CHART_DATA);
    //   chartList.push(NIFTY_SPOT_OIX_CHART_DATA);
    //   chartList.push(BANKNIFTY_SPOT_OIX_CHART_DATA);
    //   chartList.push(FINNIFTY_SPOT_OIX_CHART_DATA);
    //   chartList.push(MIDCPNIFTY_SPOT_OIX_CHART_DATA);
    //   chartList.push(NIFTY_ALLOPT_DOIX_CHART_DATA);
    //   chartList.push(BANKNIFTY_ALLOPT_DOIX_CHART_DATA);
    //   chartList.push(FINNIFTY_ALLOPT_DOIX_CHART_DATA);
    //   chartList.push(MIDCPNIFTY_ALLOPT_DOIX_CHART_DATA);
    //   chartList.push(NIFTY_GCASH_BAR_CHART_DATA);
    //   chartList.push(BANKNIFTY_GCASH_BAR_CHART_DATA);
    //   chartList.push(FINNIFTY_GCASH_BAR_CHART_DATA);
    //   chartList.push(MIDCPNIFTY_GCASH_BAR_CHART_DATA);

    //   chartList.push(NIFTY_OI_BAR_CHART_DATA);
    //   chartList.push(BANKNIFTY_OI_BAR_CHART_DATA);
    //   chartList.push(FINNIFTY_OI_BAR_CHART_DATA);
    //   chartList.push(MIDCPNIFTY_OI_BAR_CHART_DATA);
    //   chartList.push(NIFTY_IV_CHART_DATA);
    //   chartList.push(BANKNIFTY_IV_CHART_DATA);

    //   chartList.push(NIFTY_ALLOPT_DOI_CHART_DATA);
    //   chartList.push(BANKNIFTY_ALLOPT_DOI_CHART_DATA);
    //   chartList.push(FINNIFTY_ALLOPT_DOI_CHART_DATA);
    //   chartList.push(MIDCPNIFTY_ALLOPT_DOI_CHART_DATA);
    //   chartList.push(NIFTY_ALLOPT_DVOLX_CHART_DATA);
    //   chartList.push(BANKNIFTY_ALLOPT_DVOLX_CHART_DATA);
    //   chartList.push(FINNIFTY_ALLOPT_DVOLX_CHART_DATA);
    //   chartList.push(MIDCPNIFTY_ALLOPT_DVOLX_CHART_DATA);
    //   chartList.push(NIFTY_ALLOPT_VOL_CHART_DATA);
    //   chartList.push(BANKNIFTY_ALLOPT_VOL_CHART_DATA);
    //   chartList.push(FINNIFTY_ALLOPT_VOL_CHART_DATA);
    //   chartList.push(MIDCPNIFTY_ALLOPT_VOL_CHART_DATA);

    //   chartList.push(NIFTY_SNAKE_CHART_DATA);
    //   chartList.push(BANKNIFTY_SNAKE_CHART_DATA);
    //   chartList.push(FINNIFTY_SNAKE_CHART_DATA);
    //   chartList.push(MIDCPNIFTY_SNAKE_CHART_DATA);
    //   chartList.push(NIFTY_HV_CHART_DATA);
    //   chartList.push(BANKNIFTY_HV_CHART_DATA);
    // }else if(isPRO_1 || isFastData){
    //   chartList.push(NIFTY_ALLOPT_VOLX_CHART_DATA);
    //   chartList.push(BANKNIFTY_ALLOPT_VOLX_CHART_DATA);
    //   chartList.push(FINNIFTY_ALLOPT_VOLX_CHART_DATA);
    //   chartList.push(MIDCPNIFTY_ALLOPT_VOLX_CHART_DATA);
    //   chartList.push(NIFTY_SPOT_OIX_CHART_DATA);
    //   chartList.push(BANKNIFTY_SPOT_OIX_CHART_DATA);
    //   chartList.push(FINNIFTY_SPOT_OIX_CHART_DATA);
    //   chartList.push(MIDCPNIFTY_SPOT_OIX_CHART_DATA);
    //   chartList.push(NIFTY_ALLOPT_DOIX_CHART_DATA);
    //   chartList.push(BANKNIFTY_ALLOPT_DOIX_CHART_DATA);
    //   chartList.push(FINNIFTY_ALLOPT_DOIX_CHART_DATA);
    //   chartList.push(MIDCPNIFTY_ALLOPT_DOIX_CHART_DATA);
    //   chartList.push(NIFTY_GCASH_BAR_CHART_DATA);
    //   chartList.push(BANKNIFTY_GCASH_BAR_CHART_DATA);
    //   chartList.push(FINNIFTY_GCASH_BAR_CHART_DATA);
    //   chartList.push(MIDCPNIFTY_GCASH_BAR_CHART_DATA);

    //   chartList.push(NIFTY_OI_BAR_CHART_DATA);
    //   chartList.push(BANKNIFTY_OI_BAR_CHART_DATA);
    //   chartList.push(FINNIFTY_OI_BAR_CHART_DATA);
    //   chartList.push(MIDCPNIFTY_OI_BAR_CHART_DATA);
    //   chartList.push(NIFTY_IV_CHART_DATA);
    //   chartList.push(BANKNIFTY_IV_CHART_DATA);

    //   chartList.push(NIFTY_ALLOPT_DOI_CHART_DATA);
    //   chartList.push(BANKNIFTY_ALLOPT_DOI_CHART_DATA);
    //   chartList.push(FINNIFTY_ALLOPT_DOI_CHART_DATA);
    //   chartList.push(MIDCPNIFTY_ALLOPT_DOI_CHART_DATA);
    //   chartList.push(NIFTY_ALLOPT_VOL_CHART_DATA);
    //   chartList.push(BANKNIFTY_ALLOPT_VOL_CHART_DATA);
    //   chartList.push(FINNIFTY_ALLOPT_VOL_CHART_DATA);
    //   chartList.push(MIDCPNIFTY_ALLOPT_VOL_CHART_DATA);

    //   chartList.push(NIFTY_SNAKE_CHART_DATA);
    //   chartList.push(BANKNIFTY_SNAKE_CHART_DATA);
    //   chartList.push(FINNIFTY_SNAKE_CHART_DATA);
    //   chartList.push(MIDCPNIFTY_SNAKE_CHART_DATA);
    //   chartList.push(NIFTY_HV_CHART_DATA);
    //   chartList.push(BANKNIFTY_HV_CHART_DATA);
    // // }
    // // else if(isFastData){
    // //   chartList.push(NIFTY_ALLOPT_DOI_CHART_DATA);
    // //   chartList.push(BANKNIFTY_ALLOPT_DOI_CHART_DATA);
    // //   chartList.push(FINNIFTY_ALLOPT_DOI_CHART_DATA);
    // //   chartList.push(MIDCPNIFTY_ALLOPT_DOI_CHART_DATA);
    // //   chartList.push(NIFTY_ALLOPT_VOL_CHART_DATA);
    // //   chartList.push(BANKNIFTY_ALLOPT_VOL_CHART_DATA);
    // //   chartList.push(FINNIFTY_ALLOPT_VOL_CHART_DATA);
    // //   chartList.push(MIDCPNIFTY_ALLOPT_VOL_CHART_DATA);
    // //   chartList.push(NIFTY_OI_BAR_CHART_DATA);
    // //   chartList.push(BANKNIFTY_OI_BAR_CHART_DATA);
    // //   chartList.push(FINNIFTY_OI_BAR_CHART_DATA);
    // //   chartList.push(MIDCPNIFTY_OI_BAR_CHART_DATA);
    // //   chartList.push(NIFTY_IV_CHART_DATA);
    // //   chartList.push(BANKNIFTY_IV_CHART_DATA);
    // //   chartList.push(NIFTY_SNAKE_CHART_DATA);
    // //   chartList.push(BANKNIFTY_SNAKE_CHART_DATA);
    // //   chartList.push(FINNIFTY_SNAKE_CHART_DATA);
    // //   chartList.push(MIDCPNIFTY_SNAKE_CHART_DATA);
    // //   chartList.push(NIFTY_HV_CHART_DATA);
    // //   chartList.push(BANKNIFTY_HV_CHART_DATA);
    // }else{
    //   // basic user has no options to display
    // }
    return chartList;
};
